/* VINYLPAC generator stand-ins (10/11; 10/12 round 2). Josh: "the jar is supposed to animate the moment you open it".
 *
 * A stand-in is a short clip of the generator's own opening, rendered frame by frame by the site's own 3D code
 * (tools/standins). It plays in the stage from the card's first frame while the live 3D loads (held, undrawn), then
 * the live 3D takes over on the same frame: VPJarPreview.seekIntro(t) draws the live jar at the clip time on screen
 * and the clip is hidden in the same task. Hard swap, no fade.
 *
 * It is used only when it is exactly what the live viewer would draw: the same jar and finish (spec key), a clip made
 * for this stage size and aspect, an engine the hand-off was verified on, a visible page and a decision made before the
 * stage ever showed (on the local preview also a fingerprint the stand-ins daemon still vouches for). Anything else
 * runs live-only, as before.
 *
 * Player (10/12): the clip is decoded with WebCodecs in a worker and drawn on an OffscreenCanvas, on the clip's own
 * clock: no media-element autoplay rules (iOS Low Power Mode refuses video playback, not this), no buffering
 * heuristics (Safari waited for ~4 s of buffer before starting), it keeps moving while the page's main thread is busy,
 * and the frame on screen is known exactly. The opening hold stretches (up to HOLD_CAP) until the lid's frames can
 * play through, so a slow link never stutters the lid. Its opening bytes go first; the live jar's files follow; the
 * rest of the clip (the turn) comes last. Browsers without WebCodecs/OffscreenCanvas get the <video> player.
 *
 * Hand-off moments: the first calm moment of the intro (before the lid moves, or after it lands) once the live jar
 * and its view thumbnails are ready; otherwise as soon as the live jar can show (VPJarPreview.revealReady: labels on,
 * a raised emboss given up to RELIEF_WAIT, like the reveal without a clip) on a touch, a view pick or a finish change.
 *
 * ?vpstandin=off forces live-only. ?vpstandin=debug shows "clip"/"live" and the hand-off time in the stage.
 * ?vpstandin=manual (tests): no automatic hand-off; only a touch, a view pick, a finish change or userAction().
 * ?vpstandin=video / =canvas (tests) pick the player; modes combine with commas (debug,video).
 * The data region below is written by tools/standins (and gated by the theme build). Never edit it by hand.
 *
 * Early downloads (all 3D builder pages, this file is their one owner): the live 3D's model, artwork manifests and
 * module graph start with the page. The viewers take a started response once (window.vpEarly.take) rather than
 * request it again: Safari never reuses <link rel=preload as=fetch> for fetch().
 */
(function () {
  'use strict';
  if (window.VPStandin) return;

  var early = window.vpEarly = window.vpEarly || (function () {
    var map = {};
    function abs(href) { try { return new URL(href, location.href).href; } catch (e) { return String(href); } }
    return {
      get: function (href, priority, cache, gate) {
        var url = abs(href);
        if (!map[url]) {
          var init = { credentials: 'same-origin' };
          if (cache) init.cache = cache;
          if (priority) init.priority = priority;
          map[url] = gate ? gate.then(function () { return fetch(url, init); }) : fetch(url, init);
          var pending = map[url];
          pending.catch(function () { if (map[url] === pending) delete map[url]; });
        }
        return map[url];
      },
      take: function (href) { var url = abs(href), p = map[url] || null; delete map[url]; return p; }
    };
  })();

  var DATA = /*@@VP-STANDIN-DATA@@*/{"entries":{"jars|black4oz|bare":{"aspect":1,"buckets":[{"bytes":36993,"clip":(window.VP_CDN+"standins__jars-4oz__496.mp4?v=b105526cd0"),"codec":"avc1.640028","intro":36992,"poster":(window.VP_CDN+"standins__jars-4oz__496.poster.bin?v=3c854a6340"),"size":496,"still":(window.VP_CDN+"standins__jars-4oz__496.still.bin?v=54a36cb500")},{"bytes":41436,"clip":(window.VP_CDN+"standins__jars-4oz__536.mp4?v=4306ba21ff"),"codec":"avc1.640028","intro":41435,"poster":(window.VP_CDN+"standins__jars-4oz__536.poster.bin?v=ccf0bbbb68"),"size":536,"still":(window.VP_CDN+"standins__jars-4oz__536.still.bin?v=19d7fddd40")},{"bytes":48728,"clip":(window.VP_CDN+"standins__jars-4oz__620.mp4?v=1910f3c0a8"),"codec":"avc1.640028","intro":48727,"poster":(window.VP_CDN+"standins__jars-4oz__620.poster.bin?v=8365ea9dcb"),"size":620,"still":(window.VP_CDN+"standins__jars-4oz__620.still.bin?v=3c791158ad")},{"bytes":49886,"clip":(window.VP_CDN+"standins__jars-4oz__636.mp4?v=5b2ce59707"),"codec":"avc1.640028","intro":49885,"poster":(window.VP_CDN+"standins__jars-4oz__636.poster.bin?v=0254caead2"),"size":636,"still":(window.VP_CDN+"standins__jars-4oz__636.still.bin?v=0bd189bcac")},{"bytes":51189,"clip":(window.VP_CDN+"standins__jars-4oz__646.mp4?v=df11f85900"),"codec":"avc1.640028","intro":51188,"poster":(window.VP_CDN+"standins__jars-4oz__646.poster.bin?v=0c70e8ae85"),"size":646,"still":(window.VP_CDN+"standins__jars-4oz__646.still.bin?v=0068911f4c")},{"bytes":52427,"clip":(window.VP_CDN+"standins__jars-4oz__660.mp4?v=2c5e9c4406"),"codec":"avc1.640028","intro":52426,"poster":(window.VP_CDN+"standins__jars-4oz__660.poster.bin?v=8c8f600bd2"),"size":660,"still":(window.VP_CDN+"standins__jars-4oz__660.still.bin?v=51c8201409")},{"bytes":52639,"clip":(window.VP_CDN+"standins__jars-4oz__676.mp4?v=ef8b334951"),"codec":"avc1.640028","intro":52638,"poster":(window.VP_CDN+"standins__jars-4oz__676.poster.bin?v=b449dad27e"),"size":676,"still":(window.VP_CDN+"standins__jars-4oz__676.still.bin?v=00774e5c33")},{"bytes":54371,"clip":(window.VP_CDN+"standins__jars-4oz__682.mp4?v=b0d8f0a701"),"codec":"avc1.640028","intro":54370,"poster":(window.VP_CDN+"standins__jars-4oz__682.poster.bin?v=fab0f67b4f"),"size":682,"still":(window.VP_CDN+"standins__jars-4oz__682.still.bin?v=9c6b164970")},{"bytes":55366,"clip":(window.VP_CDN+"standins__jars-4oz__700.mp4?v=2b49245b33"),"codec":"avc1.640028","intro":55365,"poster":(window.VP_CDN+"standins__jars-4oz__700.poster.bin?v=b56d63ac6f"),"size":700,"still":(window.VP_CDN+"standins__jars-4oz__700.still.bin?v=e40fad97f7")},{"bytes":58167,"clip":(window.VP_CDN+"standins__jars-4oz__724.mp4?v=bcee59c852"),"codec":"avc1.640028","intro":58166,"poster":(window.VP_CDN+"standins__jars-4oz__724.poster.bin?v=5a26ac88f2"),"size":724,"still":(window.VP_CDN+"standins__jars-4oz__724.still.bin?v=7070b482f9")},{"bytes":59540,"clip":(window.VP_CDN+"standins__jars-4oz__744.mp4?v=53b0b41531"),"codec":"avc1.640028","intro":59539,"poster":(window.VP_CDN+"standins__jars-4oz__744.poster.bin?v=9bd084e59c"),"size":744,"still":(window.VP_CDN+"standins__jars-4oz__744.still.bin?v=0fe62af42e")},{"bytes":60672,"clip":(window.VP_CDN+"standins__jars-4oz__752.mp4?v=4e53397cf6"),"codec":"avc1.640028","intro":60671,"poster":(window.VP_CDN+"standins__jars-4oz__752.poster.bin?v=23c54d7818"),"size":752,"still":(window.VP_CDN+"standins__jars-4oz__752.still.bin?v=1a0109279a")},{"bytes":60946,"clip":(window.VP_CDN+"standins__jars-4oz__756.mp4?v=bdf0c6c324"),"codec":"avc1.640028","intro":60945,"poster":(window.VP_CDN+"standins__jars-4oz__756.poster.bin?v=5099b0f822"),"size":756,"still":(window.VP_CDN+"standins__jars-4oz__756.still.bin?v=b41659054a")},{"bytes":62760,"clip":(window.VP_CDN+"standins__jars-4oz__776.mp4?v=e55420cbbf"),"codec":"avc1.640028","intro":62759,"poster":(window.VP_CDN+"standins__jars-4oz__776.poster.bin?v=4b06d2cb3a"),"size":776,"still":(window.VP_CDN+"standins__jars-4oz__776.still.bin?v=8145697199")},{"bytes":69058,"clip":(window.VP_CDN+"standins__jars-4oz__836.mp4?v=7b5e475a64"),"codec":"avc1.640028","intro":69057,"poster":(window.VP_CDN+"standins__jars-4oz__836.poster.bin?v=b9df6f3f36"),"size":836,"still":(window.VP_CDN+"standins__jars-4oz__836.still.bin?v=a3d2593fb3")},{"bytes":69067,"clip":(window.VP_CDN+"standins__jars-4oz__842.mp4?v=0f705264f1"),"codec":"avc1.640028","intro":69066,"poster":(window.VP_CDN+"standins__jars-4oz__842.poster.bin?v=7ff88d0492"),"size":842,"still":(window.VP_CDN+"standins__jars-4oz__842.still.bin?v=a3819964b3")},{"bytes":74699,"clip":(window.VP_CDN+"standins__jars-4oz__896.mp4?v=214fcdb5b1"),"codec":"avc1.640028","intro":74698,"poster":(window.VP_CDN+"standins__jars-4oz__896.poster.bin?v=5330bf753d"),"size":896,"still":(window.VP_CDN+"standins__jars-4oz__896.still.bin?v=69ebc3c6ea")},{"bytes":84043,"clip":(window.VP_CDN+"standins__jars-4oz__992.mp4?v=aff9da3fc4"),"codec":"avc1.640028","intro":84042,"poster":(window.VP_CDN+"standins__jars-4oz__992.poster.bin?v=c4a8af2f5f"),"size":992,"still":(window.VP_CDN+"standins__jars-4oz__992.still.bin?v=42d6b73725")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"48dbc29e91145a4b","fps":60,"frames":163,"page":"jars","spec":{"jar":"black4oz","labels":false},"thumbs":(window.VP_CDN+"standins__jars-4oz__thumbs.bin?v=f2094493f9")},"jars|ceres|bare":{"aspect":1,"buckets":[{"bytes":42842,"clip":(window.VP_CDN+"standins__jars-ceres__496.mp4?v=68475ad907"),"codec":"avc1.640028","intro":42841,"poster":(window.VP_CDN+"standins__jars-ceres__496.poster.bin?v=7a2cca808b"),"size":496,"still":(window.VP_CDN+"standins__jars-ceres__496.still.bin?v=acdf0eea25")},{"bytes":47243,"clip":(window.VP_CDN+"standins__jars-ceres__536.mp4?v=df41fd28ae"),"codec":"avc1.640028","intro":47242,"poster":(window.VP_CDN+"standins__jars-ceres__536.poster.bin?v=0db1f6284d"),"size":536,"still":(window.VP_CDN+"standins__jars-ceres__536.still.bin?v=2badfa6ed5")},{"bytes":55159,"clip":(window.VP_CDN+"standins__jars-ceres__620.mp4?v=917e1124d6"),"codec":"avc1.640028","intro":55158,"poster":(window.VP_CDN+"standins__jars-ceres__620.poster.bin?v=d45c8701c6"),"size":620,"still":(window.VP_CDN+"standins__jars-ceres__620.still.bin?v=57f8c31bdd")},{"bytes":57172,"clip":(window.VP_CDN+"standins__jars-ceres__636.mp4?v=63643af71a"),"codec":"avc1.640028","intro":57171,"poster":(window.VP_CDN+"standins__jars-ceres__636.poster.bin?v=1c3a5cfaeb"),"size":636,"still":(window.VP_CDN+"standins__jars-ceres__636.still.bin?v=9dc46e4d4c")},{"bytes":57230,"clip":(window.VP_CDN+"standins__jars-ceres__646.mp4?v=2027255b51"),"codec":"avc1.640028","intro":57229,"poster":(window.VP_CDN+"standins__jars-ceres__646.poster.bin?v=b4e550f17a"),"size":646,"still":(window.VP_CDN+"standins__jars-ceres__646.still.bin?v=2de24dbab6")},{"bytes":60546,"clip":(window.VP_CDN+"standins__jars-ceres__660.mp4?v=d2cf6a884a"),"codec":"avc1.640028","intro":60545,"poster":(window.VP_CDN+"standins__jars-ceres__660.poster.bin?v=145e782a63"),"size":660,"still":(window.VP_CDN+"standins__jars-ceres__660.still.bin?v=3e5600a930")},{"bytes":62371,"clip":(window.VP_CDN+"standins__jars-ceres__676.mp4?v=e70d0bf9ee"),"codec":"avc1.640028","intro":62370,"poster":(window.VP_CDN+"standins__jars-ceres__676.poster.bin?v=91949e81d5"),"size":676,"still":(window.VP_CDN+"standins__jars-ceres__676.still.bin?v=09c6310942")},{"bytes":62290,"clip":(window.VP_CDN+"standins__jars-ceres__682.mp4?v=cc78a4e0d5"),"codec":"avc1.640028","intro":62289,"poster":(window.VP_CDN+"standins__jars-ceres__682.poster.bin?v=77fdc67302"),"size":682,"still":(window.VP_CDN+"standins__jars-ceres__682.still.bin?v=1469d20ae7")},{"bytes":64213,"clip":(window.VP_CDN+"standins__jars-ceres__700.mp4?v=2a018b846f"),"codec":"avc1.640028","intro":64212,"poster":(window.VP_CDN+"standins__jars-ceres__700.poster.bin?v=0e73b06a28"),"size":700,"still":(window.VP_CDN+"standins__jars-ceres__700.still.bin?v=6f636c28cc")},{"bytes":66424,"clip":(window.VP_CDN+"standins__jars-ceres__724.mp4?v=f5693d95ba"),"codec":"avc1.640028","intro":66423,"poster":(window.VP_CDN+"standins__jars-ceres__724.poster.bin?v=c310db32d9"),"size":724,"still":(window.VP_CDN+"standins__jars-ceres__724.still.bin?v=d88a5e1c1f")},{"bytes":69514,"clip":(window.VP_CDN+"standins__jars-ceres__744.mp4?v=6fced3b61d"),"codec":"avc1.640028","intro":69513,"poster":(window.VP_CDN+"standins__jars-ceres__744.poster.bin?v=25c476cbac"),"size":744,"still":(window.VP_CDN+"standins__jars-ceres__744.still.bin?v=31a5dafc22")},{"bytes":69616,"clip":(window.VP_CDN+"standins__jars-ceres__752.mp4?v=0563345025"),"codec":"avc1.640028","intro":69615,"poster":(window.VP_CDN+"standins__jars-ceres__752.poster.bin?v=152b82877c"),"size":752,"still":(window.VP_CDN+"standins__jars-ceres__752.still.bin?v=326173e5b4")},{"bytes":70798,"clip":(window.VP_CDN+"standins__jars-ceres__756.mp4?v=3a2b2659b2"),"codec":"avc1.640028","intro":70797,"poster":(window.VP_CDN+"standins__jars-ceres__756.poster.bin?v=17fe258254"),"size":756,"still":(window.VP_CDN+"standins__jars-ceres__756.still.bin?v=126089e696")},{"bytes":72068,"clip":(window.VP_CDN+"standins__jars-ceres__776.mp4?v=587a804456"),"codec":"avc1.640028","intro":72067,"poster":(window.VP_CDN+"standins__jars-ceres__776.poster.bin?v=9c6de52db7"),"size":776,"still":(window.VP_CDN+"standins__jars-ceres__776.still.bin?v=44945ffbac")},{"bytes":80621,"clip":(window.VP_CDN+"standins__jars-ceres__836.mp4?v=9f35a1234c"),"codec":"avc1.640028","intro":80620,"poster":(window.VP_CDN+"standins__jars-ceres__836.poster.bin?v=e3e888767f"),"size":836,"still":(window.VP_CDN+"standins__jars-ceres__836.still.bin?v=124575d98e")},{"bytes":81646,"clip":(window.VP_CDN+"standins__jars-ceres__842.mp4?v=ee7cef6a91"),"codec":"avc1.640028","intro":81645,"poster":(window.VP_CDN+"standins__jars-ceres__842.poster.bin?v=61cf2c54f6"),"size":842,"still":(window.VP_CDN+"standins__jars-ceres__842.still.bin?v=eb857bcde8")},{"bytes":86272,"clip":(window.VP_CDN+"standins__jars-ceres__896.mp4?v=935cc17736"),"codec":"avc1.640028","intro":86271,"poster":(window.VP_CDN+"standins__jars-ceres__896.poster.bin?v=b818476e2f"),"size":896,"still":(window.VP_CDN+"standins__jars-ceres__896.still.bin?v=ae3785a7a1")},{"bytes":99715,"clip":(window.VP_CDN+"standins__jars-ceres__992.mp4?v=8c208fabe7"),"codec":"avc1.640028","intro":99714,"poster":(window.VP_CDN+"standins__jars-ceres__992.poster.bin?v=27b620a784"),"size":992,"still":(window.VP_CDN+"standins__jars-ceres__992.still.bin?v=bc6191cb32")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"abeb25d370c1d9ec","fps":60,"frames":163,"page":"jars","spec":{"jar":"ceres","labels":false},"thumbs":(window.VP_CDN+"standins__jars-ceres__thumbs.bin?v=4f84e94c83")},"jars|eris|bare":{"aspect":1,"buckets":[{"bytes":46661,"clip":(window.VP_CDN+"standins__jars-eris__496.mp4?v=6b86f948b5"),"codec":"avc1.640028","intro":46660,"poster":(window.VP_CDN+"standins__jars-eris__496.poster.bin?v=96466efeb8"),"size":496,"still":(window.VP_CDN+"standins__jars-eris__496.still.bin?v=a1795c3f20")},{"bytes":50566,"clip":(window.VP_CDN+"standins__jars-eris__536.mp4?v=3aae0cc046"),"codec":"avc1.640028","intro":50565,"poster":(window.VP_CDN+"standins__jars-eris__536.poster.bin?v=9cb2763557"),"size":536,"still":(window.VP_CDN+"standins__jars-eris__536.still.bin?v=cbae812920")},{"bytes":58995,"clip":(window.VP_CDN+"standins__jars-eris__620.mp4?v=77842d33ff"),"codec":"avc1.640028","intro":58994,"poster":(window.VP_CDN+"standins__jars-eris__620.poster.bin?v=b6ba756189"),"size":620,"still":(window.VP_CDN+"standins__jars-eris__620.still.bin?v=87e940781e")},{"bytes":61455,"clip":(window.VP_CDN+"standins__jars-eris__636.mp4?v=fffd269e04"),"codec":"avc1.640028","intro":61454,"poster":(window.VP_CDN+"standins__jars-eris__636.poster.bin?v=4ed2aac167"),"size":636,"still":(window.VP_CDN+"standins__jars-eris__636.still.bin?v=1307b34710")},{"bytes":63218,"clip":(window.VP_CDN+"standins__jars-eris__646.mp4?v=31791ff93e"),"codec":"avc1.640028","intro":63217,"poster":(window.VP_CDN+"standins__jars-eris__646.poster.bin?v=90101902b9"),"size":646,"still":(window.VP_CDN+"standins__jars-eris__646.still.bin?v=67234d2ab9")},{"bytes":64062,"clip":(window.VP_CDN+"standins__jars-eris__660.mp4?v=bb9c5d6d81"),"codec":"avc1.640028","intro":64061,"poster":(window.VP_CDN+"standins__jars-eris__660.poster.bin?v=842b5a849c"),"size":660,"still":(window.VP_CDN+"standins__jars-eris__660.still.bin?v=742757b1a0")},{"bytes":67179,"clip":(window.VP_CDN+"standins__jars-eris__676.mp4?v=0045680e03"),"codec":"avc1.640028","intro":67178,"poster":(window.VP_CDN+"standins__jars-eris__676.poster.bin?v=312e02a2eb"),"size":676,"still":(window.VP_CDN+"standins__jars-eris__676.still.bin?v=ce6afff778")},{"bytes":67918,"clip":(window.VP_CDN+"standins__jars-eris__682.mp4?v=1ac1555dc4"),"codec":"avc1.640028","intro":67917,"poster":(window.VP_CDN+"standins__jars-eris__682.poster.bin?v=de5a913554"),"size":682,"still":(window.VP_CDN+"standins__jars-eris__682.still.bin?v=d45a5b7d6f")},{"bytes":69680,"clip":(window.VP_CDN+"standins__jars-eris__700.mp4?v=e60bdbd566"),"codec":"avc1.640028","intro":69679,"poster":(window.VP_CDN+"standins__jars-eris__700.poster.bin?v=534410ea00"),"size":700,"still":(window.VP_CDN+"standins__jars-eris__700.still.bin?v=a38460e69f")},{"bytes":73144,"clip":(window.VP_CDN+"standins__jars-eris__724.mp4?v=584c3a8b12"),"codec":"avc1.640028","intro":73143,"poster":(window.VP_CDN+"standins__jars-eris__724.poster.bin?v=8579dc9039"),"size":724,"still":(window.VP_CDN+"standins__jars-eris__724.still.bin?v=13aab5cfe8")},{"bytes":74436,"clip":(window.VP_CDN+"standins__jars-eris__744.mp4?v=6164d16199"),"codec":"avc1.640028","intro":74435,"poster":(window.VP_CDN+"standins__jars-eris__744.poster.bin?v=891a6fcfa2"),"size":744,"still":(window.VP_CDN+"standins__jars-eris__744.still.bin?v=237e0adc7b")},{"bytes":75294,"clip":(window.VP_CDN+"standins__jars-eris__752.mp4?v=dae4991c2e"),"codec":"avc1.640028","intro":75293,"poster":(window.VP_CDN+"standins__jars-eris__752.poster.bin?v=1c1c1d5679"),"size":752,"still":(window.VP_CDN+"standins__jars-eris__752.still.bin?v=ba96f2371a")},{"bytes":75938,"clip":(window.VP_CDN+"standins__jars-eris__756.mp4?v=4e04738e4f"),"codec":"avc1.640028","intro":75937,"poster":(window.VP_CDN+"standins__jars-eris__756.poster.bin?v=bdfb292632"),"size":756,"still":(window.VP_CDN+"standins__jars-eris__756.still.bin?v=483a304d38")},{"bytes":78544,"clip":(window.VP_CDN+"standins__jars-eris__776.mp4?v=d8a1470335"),"codec":"avc1.640028","intro":78543,"poster":(window.VP_CDN+"standins__jars-eris__776.poster.bin?v=0ef0b639ad"),"size":776,"still":(window.VP_CDN+"standins__jars-eris__776.still.bin?v=0114a1154a")},{"bytes":86104,"clip":(window.VP_CDN+"standins__jars-eris__836.mp4?v=56b10e4686"),"codec":"avc1.640028","intro":86103,"poster":(window.VP_CDN+"standins__jars-eris__836.poster.bin?v=2bbaed69fc"),"size":836,"still":(window.VP_CDN+"standins__jars-eris__836.still.bin?v=585d7cebcb")},{"bytes":87848,"clip":(window.VP_CDN+"standins__jars-eris__842.mp4?v=1ae1b09f57"),"codec":"avc1.640028","intro":87847,"poster":(window.VP_CDN+"standins__jars-eris__842.poster.bin?v=d27f7e331b"),"size":842,"still":(window.VP_CDN+"standins__jars-eris__842.still.bin?v=cf23f27116")},{"bytes":95039,"clip":(window.VP_CDN+"standins__jars-eris__896.mp4?v=cb8fa7ffb0"),"codec":"avc1.640028","intro":95038,"poster":(window.VP_CDN+"standins__jars-eris__896.poster.bin?v=1f74e37ec0"),"size":896,"still":(window.VP_CDN+"standins__jars-eris__896.still.bin?v=0de97d9c3d")},{"bytes":104047,"clip":(window.VP_CDN+"standins__jars-eris__992.mp4?v=aad7191d2d"),"codec":"avc1.640028","intro":104046,"poster":(window.VP_CDN+"standins__jars-eris__992.poster.bin?v=a9037fe4b3"),"size":992,"still":(window.VP_CDN+"standins__jars-eris__992.still.bin?v=0223a419b0")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"994526377aba16ee","fps":60,"frames":163,"page":"jars","spec":{"jar":"eris","labels":false},"thumbs":(window.VP_CDN+"standins__jars-eris__thumbs.bin?v=1f8065bbbc")},"jars|saturn|bare":{"aspect":1,"buckets":[{"bytes":35470,"clip":(window.VP_CDN+"standins__jars-150__496.mp4?v=058d99f8d8"),"codec":"avc1.640028","intro":35469,"poster":(window.VP_CDN+"standins__jars-150__496.poster.bin?v=3d464c5f1e"),"size":496,"still":(window.VP_CDN+"standins__jars-150__496.still.bin?v=c5a8f95ca2")},{"bytes":38687,"clip":(window.VP_CDN+"standins__jars-150__536.mp4?v=579d523710"),"codec":"avc1.640028","intro":38686,"poster":(window.VP_CDN+"standins__jars-150__536.poster.bin?v=18ef70f496"),"size":536,"still":(window.VP_CDN+"standins__jars-150__536.still.bin?v=a089d5a2f3")},{"bytes":45106,"clip":(window.VP_CDN+"standins__jars-150__620.mp4?v=2596439682"),"codec":"avc1.640028","intro":45105,"poster":(window.VP_CDN+"standins__jars-150__620.poster.bin?v=71cd441422"),"size":620,"still":(window.VP_CDN+"standins__jars-150__620.still.bin?v=6c03770f7a")},{"bytes":55535,"clip":(window.VP_CDN+"standins__jars-150__636.mp4?v=565ec9b009"),"codec":"avc1.640028","intro":55534,"poster":(window.VP_CDN+"standins__jars-150__636.poster.bin?v=dd96ccd842"),"size":636,"still":(window.VP_CDN+"standins__jars-150__636.still.bin?v=c87204b0a5")},{"bytes":47059,"clip":(window.VP_CDN+"standins__jars-150__646.mp4?v=3ef1def508"),"codec":"avc1.640028","intro":47058,"poster":(window.VP_CDN+"standins__jars-150__646.poster.bin?v=ceffea3ad1"),"size":646,"still":(window.VP_CDN+"standins__jars-150__646.still.bin?v=b122abe9fc")},{"bytes":49092,"clip":(window.VP_CDN+"standins__jars-150__660.mp4?v=a5ceca2127"),"codec":"avc1.640028","intro":49091,"poster":(window.VP_CDN+"standins__jars-150__660.poster.bin?v=05305e929f"),"size":660,"still":(window.VP_CDN+"standins__jars-150__660.still.bin?v=e78cf93fcf")},{"bytes":49964,"clip":(window.VP_CDN+"standins__jars-150__676.mp4?v=566ffb388e"),"codec":"avc1.640028","intro":49963,"poster":(window.VP_CDN+"standins__jars-150__676.poster.bin?v=8d4ba35459"),"size":676,"still":(window.VP_CDN+"standins__jars-150__676.still.bin?v=a5da36b0b3")},{"bytes":50902,"clip":(window.VP_CDN+"standins__jars-150__682.mp4?v=ff708a18c5"),"codec":"avc1.640028","intro":50901,"poster":(window.VP_CDN+"standins__jars-150__682.poster.bin?v=1cf73654ef"),"size":682,"still":(window.VP_CDN+"standins__jars-150__682.still.bin?v=e232b9ec46")},{"bytes":53355,"clip":(window.VP_CDN+"standins__jars-150__700.mp4?v=654ec55e5a"),"codec":"avc1.640028","intro":53354,"poster":(window.VP_CDN+"standins__jars-150__700.poster.bin?v=f9815db29c"),"size":700,"still":(window.VP_CDN+"standins__jars-150__700.still.bin?v=618dba7f5e")},{"bytes":54266,"clip":(window.VP_CDN+"standins__jars-150__724.mp4?v=4e0102ec81"),"codec":"avc1.640028","intro":54265,"poster":(window.VP_CDN+"standins__jars-150__724.poster.bin?v=0a0d58f21d"),"size":724,"still":(window.VP_CDN+"standins__jars-150__724.still.bin?v=04284ebabe")},{"bytes":57391,"clip":(window.VP_CDN+"standins__jars-150__744.mp4?v=0bdfeafbb0"),"codec":"avc1.640028","intro":57390,"poster":(window.VP_CDN+"standins__jars-150__744.poster.bin?v=c864635ddd"),"size":744,"still":(window.VP_CDN+"standins__jars-150__744.still.bin?v=254846de82")},{"bytes":57558,"clip":(window.VP_CDN+"standins__jars-150__752.mp4?v=d40f0cf51a"),"codec":"avc1.640028","intro":57557,"poster":(window.VP_CDN+"standins__jars-150__752.poster.bin?v=143fd82c86"),"size":752,"still":(window.VP_CDN+"standins__jars-150__752.still.bin?v=039d8458d0")},{"bytes":58199,"clip":(window.VP_CDN+"standins__jars-150__756.mp4?v=19d7082784"),"codec":"avc1.640028","intro":58198,"poster":(window.VP_CDN+"standins__jars-150__756.poster.bin?v=419a46c1f2"),"size":756,"still":(window.VP_CDN+"standins__jars-150__756.still.bin?v=5000c85ba5")},{"bytes":60401,"clip":(window.VP_CDN+"standins__jars-150__776.mp4?v=577dc3aaa5"),"codec":"avc1.640028","intro":60400,"poster":(window.VP_CDN+"standins__jars-150__776.poster.bin?v=13bb754429"),"size":776,"still":(window.VP_CDN+"standins__jars-150__776.still.bin?v=4fe6134a86")},{"bytes":65905,"clip":(window.VP_CDN+"standins__jars-150__836.mp4?v=7433cd2b45"),"codec":"avc1.640028","intro":65904,"poster":(window.VP_CDN+"standins__jars-150__836.poster.bin?v=d0fa14c8bc"),"size":836,"still":(window.VP_CDN+"standins__jars-150__836.still.bin?v=cf76794c1f")},{"bytes":66766,"clip":(window.VP_CDN+"standins__jars-150__842.mp4?v=6a8ac04228"),"codec":"avc1.640028","intro":66765,"poster":(window.VP_CDN+"standins__jars-150__842.poster.bin?v=c4768a22de"),"size":842,"still":(window.VP_CDN+"standins__jars-150__842.still.bin?v=da70f1aa41")},{"bytes":71139,"clip":(window.VP_CDN+"standins__jars-150__896.mp4?v=1c7e8931cd"),"codec":"avc1.640028","intro":71138,"poster":(window.VP_CDN+"standins__jars-150__896.poster.bin?v=ca25c2db2b"),"size":896,"still":(window.VP_CDN+"standins__jars-150__896.still.bin?v=bdd719614c")},{"bytes":80621,"clip":(window.VP_CDN+"standins__jars-150__992.mp4?v=eddb7d30a7"),"codec":"avc1.640028","intro":80620,"poster":(window.VP_CDN+"standins__jars-150__992.poster.bin?v=d1581f2886"),"size":992,"still":(window.VP_CDN+"standins__jars-150__992.still.bin?v=a8c4995e73")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"709a5008209ac35c","fps":60,"frames":163,"page":"jars","spec":{"jar":"saturn","labels":false},"thumbs":(window.VP_CDN+"standins__jars-150__thumbs.bin?v=f1e49944f7")},"jl|black4oz|wrap1|gloss|gloss|none|spot":{"aspect":1,"buckets":[{"bytes":1399895,"clip":(window.VP_CDN+"standins__jl-4oz__522.mp4?v=fbb15ed363"),"codec":"avc1.640028","intro":662798,"poster":(window.VP_CDN+"standins__jl-4oz__522.poster.bin?v=d08f2d335c"),"size":522,"still":(window.VP_CDN+"standins__jl-4oz__522.still.bin?v=f46a476acb")},{"bytes":1501972,"clip":(window.VP_CDN+"standins__jl-4oz__540.mp4?v=689d837625"),"codec":"avc1.640028","intro":714851,"poster":(window.VP_CDN+"standins__jl-4oz__540.poster.bin?v=5175ec920a"),"size":540,"still":(window.VP_CDN+"standins__jl-4oz__540.still.bin?v=be34d08f13")},{"bytes":1858795,"clip":(window.VP_CDN+"standins__jl-4oz__620.mp4?v=2b1873f631"),"codec":"avc1.640028","intro":868208,"poster":(window.VP_CDN+"standins__jl-4oz__620.poster.bin?v=94460b57db"),"size":620,"still":(window.VP_CDN+"standins__jl-4oz__620.still.bin?v=0ba2b4470a")},{"bytes":2087293,"clip":(window.VP_CDN+"standins__jl-4oz__672.mp4?v=cf4876e070"),"codec":"avc1.640028","intro":973217,"poster":(window.VP_CDN+"standins__jl-4oz__672.poster.bin?v=1c0624da3c"),"size":672,"still":(window.VP_CDN+"standins__jl-4oz__672.still.bin?v=54fdbd7f34")},{"bytes":2136494,"clip":(window.VP_CDN+"standins__jl-4oz__682.mp4?v=257f396068"),"codec":"avc1.640028","intro":990692,"poster":(window.VP_CDN+"standins__jl-4oz__682.poster.bin?v=1942c3dd7a"),"size":682,"still":(window.VP_CDN+"standins__jl-4oz__682.still.bin?v=951cd75ed8")},{"bytes":2152547,"clip":(window.VP_CDN+"standins__jl-4oz__686.mp4?v=57cec43928"),"codec":"avc1.640028","intro":991246,"poster":(window.VP_CDN+"standins__jl-4oz__686.poster.bin?v=a955d0afa6"),"size":686,"still":(window.VP_CDN+"standins__jl-4oz__686.still.bin?v=3c5537ebb5")},{"bytes":2215823,"clip":(window.VP_CDN+"standins__jl-4oz__696.mp4?v=21a4bc1a50"),"codec":"avc1.640028","intro":1022089,"poster":(window.VP_CDN+"standins__jl-4oz__696.poster.bin?v=ab68d49fdb"),"size":696,"still":(window.VP_CDN+"standins__jl-4oz__696.still.bin?v=b578076681")},{"bytes":3672650,"clip":(window.VP_CDN+"standins__jl-4oz__920.mp4?v=e2e845b8c7"),"codec":"avc1.640028","intro":1661409,"poster":(window.VP_CDN+"standins__jl-4oz__920.poster.bin?v=85e308bfcb"),"size":920,"still":(window.VP_CDN+"standins__jl-4oz__920.still.bin?v=c3bca9d56a")},{"bytes":3740204,"clip":(window.VP_CDN+"standins__jl-4oz__942.mp4?v=0b29820290"),"codec":"avc1.640028","intro":1700958,"poster":(window.VP_CDN+"standins__jl-4oz__942.poster.bin?v=e905e0065c"),"size":942,"still":(window.VP_CDN+"standins__jl-4oz__942.still.bin?v=a45cf818b4")},{"bytes":4202720,"clip":(window.VP_CDN+"standins__jl-4oz__1042.mp4?v=28536acd76"),"codec":"avc1.64002a","intro":1958780,"poster":(window.VP_CDN+"standins__jl-4oz__1042.poster.bin?v=5e4bdb4470"),"size":1042,"still":(window.VP_CDN+"standins__jl-4oz__1042.still.bin?v=8776ec5124")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"03335ad8d95fb113","fps":60,"frames":391,"page":"jar-labels","spec":{"emboss":"none","jar":"black4oz","labels":true,"laminate":"gloss","lidWrap":true,"material":"gloss","white":"spot"}},"jl|ceres|wrap0|gloss|gloss|none|spot":{"aspect":1,"buckets":[{"bytes":2915612,"clip":(window.VP_CDN+"standins__jl-ceres__728.mp4?v=93f23e148a"),"codec":"avc1.640028","intro":1392211,"poster":(window.VP_CDN+"standins__jl-ceres__728.poster.bin?v=637ba0c0c9"),"size":728,"still":(window.VP_CDN+"standins__jl-ceres__728.still.bin?v=0d950eb100")},{"bytes":3107666,"clip":(window.VP_CDN+"standins__jl-ceres__756.mp4?v=8afed80d88"),"codec":"avc1.640028","intro":1479152,"poster":(window.VP_CDN+"standins__jl-ceres__756.poster.bin?v=f13b42523d"),"size":756,"still":(window.VP_CDN+"standins__jl-ceres__756.still.bin?v=eecdde3b94")},{"bytes":3158332,"clip":(window.VP_CDN+"standins__jl-ceres__760.mp4?v=f61781ab77"),"codec":"avc1.640028","intro":1512892,"poster":(window.VP_CDN+"standins__jl-ceres__760.poster.bin?v=11e554b957"),"size":760,"still":(window.VP_CDN+"standins__jl-ceres__760.still.bin?v=7a15781988")},{"bytes":3296490,"clip":(window.VP_CDN+"standins__jl-ceres__780.mp4?v=b14d81311c"),"codec":"avc1.640028","intro":1582632,"poster":(window.VP_CDN+"standins__jl-ceres__780.poster.bin?v=e6084f57f9"),"size":780,"still":(window.VP_CDN+"standins__jl-ceres__780.still.bin?v=93ee690589")},{"bytes":3319805,"clip":(window.VP_CDN+"standins__jl-ceres__782.mp4?v=4cede03817"),"codec":"avc1.640028","intro":1590226,"poster":(window.VP_CDN+"standins__jl-ceres__782.poster.bin?v=fede7fc0f3"),"size":782,"still":(window.VP_CDN+"standins__jl-ceres__782.still.bin?v=fbe593b8a5")},{"bytes":3995187,"clip":(window.VP_CDN+"standins__jl-ceres__886.mp4?v=099e5c9100"),"codec":"avc1.640028","intro":1903607,"poster":(window.VP_CDN+"standins__jl-ceres__886.poster.bin?v=af23c207dc"),"size":886,"still":(window.VP_CDN+"standins__jl-ceres__886.still.bin?v=7e4996461f")},{"bytes":4160129,"clip":(window.VP_CDN+"standins__jl-ceres__920.mp4?v=bb4a993352"),"codec":"avc1.640028","intro":1981454,"poster":(window.VP_CDN+"standins__jl-ceres__920.poster.bin?v=945784332c"),"size":920,"still":(window.VP_CDN+"standins__jl-ceres__920.still.bin?v=2e1204ff06")},{"bytes":4287407,"clip":(window.VP_CDN+"standins__jl-ceres__942.mp4?v=0cb214ad2f"),"codec":"avc1.640028","intro":2050394,"poster":(window.VP_CDN+"standins__jl-ceres__942.poster.bin?v=0b834ae27c"),"size":942,"still":(window.VP_CDN+"standins__jl-ceres__942.still.bin?v=d465e3997b")},{"bytes":4806124,"clip":(window.VP_CDN+"standins__jl-ceres__1042.mp4?v=7b92907968"),"codec":"avc1.64002a","intro":2308116,"poster":(window.VP_CDN+"standins__jl-ceres__1042.poster.bin?v=f85a728482"),"size":1042,"still":(window.VP_CDN+"standins__jl-ceres__1042.still.bin?v=530860357f")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"a58c53fe638d57a2","fps":60,"frames":391,"page":"jar-labels","spec":{"emboss":"none","jar":"ceres","labels":true,"laminate":"gloss","lidWrap":false,"material":"gloss","white":"spot"}},"jl|saturn|wrap0|gloss|gloss|none|spot":{"aspect":1,"buckets":[{"bytes":1895150,"clip":(window.VP_CDN+"standins__jl-150-nowrap__782.mp4?v=ab3a75e860"),"codec":"avc1.640028","intro":847323,"poster":(window.VP_CDN+"standins__jl-150-nowrap__782.poster.bin?v=ad8e605eaa"),"size":782,"still":(window.VP_CDN+"standins__jl-150-nowrap__782.still.bin?v=52560a13f8")},{"bytes":2634323,"clip":(window.VP_CDN+"standins__jl-150-nowrap__920.mp4?v=4b31af4a03"),"codec":"avc1.640028","intro":1121807,"poster":(window.VP_CDN+"standins__jl-150-nowrap__920.poster.bin?v=496826228e"),"size":920,"still":(window.VP_CDN+"standins__jl-150-nowrap__920.still.bin?v=476477a895")},{"bytes":2764847,"clip":(window.VP_CDN+"standins__jl-150-nowrap__942.mp4?v=55dfb8021c"),"codec":"avc1.640028","intro":1164115,"poster":(window.VP_CDN+"standins__jl-150-nowrap__942.poster.bin?v=3037975853"),"size":942,"still":(window.VP_CDN+"standins__jl-150-nowrap__942.still.bin?v=ed7cc564b8")},{"bytes":3267718,"clip":(window.VP_CDN+"standins__jl-150-nowrap__1042.mp4?v=5aa65d66bb"),"codec":"avc1.64002a","intro":1382476,"poster":(window.VP_CDN+"standins__jl-150-nowrap__1042.poster.bin?v=9980954b94"),"size":1042,"still":(window.VP_CDN+"standins__jl-150-nowrap__1042.still.bin?v=1f2252f6a0")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"514c4e6966c1232a","fps":60,"frames":391,"page":"jar-labels","spec":{"emboss":"none","jar":"saturn","labels":true,"laminate":"gloss","lidWrap":false,"material":"gloss","white":"spot"}},"jl|saturn|wrap1|gloss|gloss|none|spot":{"aspect":1,"buckets":[{"bytes":3862008,"clip":(window.VP_CDN+"standins__jl-150__1042.mp4?v=3adfe385cf"),"codec":"avc1.64002a","intro":1705183,"poster":(window.VP_CDN+"standins__jl-150__1042.poster.bin?v=ad1d9b37ab"),"size":1042,"still":(window.VP_CDN+"standins__jl-150__1042.still.bin?v=15a98c933f")}],"calm":[[0,0.25],[2.6,1000]],"engines":["chromium","webkit"],"fp":"72597427d0c8f361","fps":60,"frames":391,"page":"jar-labels","spec":{"emboss":"none","jar":"saturn","labels":true,"laminate":"gloss","lidWrap":true,"material":"gloss","white":"spot"}}},"layouts":{"jar-labels":[[320,270],[510,460],[768,460],[769,315.5],[1180,521],[10000,521]],"jars":[[320,268],[470,418],[768,418],[769,298.7],[1180,495.6],[10000,495.6]]},"modules":{"jar":[(window.VP_CDN+"vendor__three__three.module.js?v=272c968f89"),(window.VP_CDN+"vendor__three__addons__controls__OrbitControls.js?v=abe4952115"),(window.VP_CDN+"vendor__three__addons__loaders__GLTFLoader.js?v=f0db271c5b"),(window.VP_CDN+"vendor__three__addons__utils__BufferGeometryUtils.js?v=a6cf69c7d3"),(window.VP_CDN+"jars-3d__cad__jar-artwork.js?v=56543d58b2"),(window.VP_CDN+"jars-3d__cad__jar-emboss-cache.js?v=d23b47ad6d"),(window.VP_CDN+"jars-3d__cad__jar-worker.js?v=9ed84d4e3e"),(window.VP_CDN+"jars-3d__cad__jar-emboss-cache-manifest.js?v=64833314d6"),(window.VP_CDN+"jars-3d__cad__jar-emboss-cache-codec.js?v=51bfbb0c89"),(window.VP_CDN+"jars-3d__cad__jar-emboss-cache-profile-wasm.js?v=86c7f9cdbc"),(window.VP_CDN+"jars-3d__cad__jar-emboss-cache-rebuild.js?v=d924d7c347"),(window.VP_CDN+"jars-3d__cad__jar-emboss-field.js?v=c0f81f8d09"),(window.VP_CDN+"jars-3d__cad__jar-finishes.js?v=8cfcd46ecb"),(window.VP_CDN+"jars-3d__cad__jar-finish-optics.js?v=daa14dcee3"),(window.VP_CDN+"jars-3d__cad__jar-emboss-surface.js?v=24f976e2bc"),(window.VP_CDN+"jars-3d__cad__jar-emboss-mask.js?v=12e3e69c88"),(window.VP_CDN+"jars-3d__cad__jar-native-boundary.js?v=acb25da11f"),(window.VP_CDN+"jars-3d__cad__jar-emboss-assets.js?v=51220def51")],"quote":[(window.VP_CDN+"vendor__three__three.module.js?v=272c968f89"),(window.VP_CDN+"vendor__three__addons__controls__OrbitControls.js?v=abe4952115"),(window.VP_CDN+"vendor__three__addons__loaders__GLTFLoader.js?v=f0db271c5b"),(window.VP_CDN+"vendor__three__addons__utils__BufferGeometryUtils.js?v=a6cf69c7d3"),(window.VP_CDN+"vendor__three__addons__libs__meshopt_decoder.module.js?v=513faf2af7"),(window.VP_CDN+"sticker-shapes.js?v=441d44d6e2"),(window.VP_CDN+"sticker-roll-geometry.js?v=e998836d81"),(window.VP_CDN+"sticker-construction-geometry.js?v=fdb086c840"),(window.VP_CDN+"lettering-contours.js?v=aed2ebb762"),(window.VP_CDN+"kisscut-transfer-geometry.js?v=6165b1b204"),(window.VP_CDN+"transfer-contours.js?v=6eb2429f6b"),(window.VP_CDN+"transfer-cut-contours.js?v=c5d48added"),(window.VP_CDN+"transfer-film-geometry.js?v=2e4d8c3193"),(window.VP_CDN+"sticker-model-metrics.js?v=b5b579a7d3")]},"tolerance":1.045,"toleranceWebkit":1.0,"version":1}/*@@END-VP-STANDIN-DATA@@*/;

  var RAW_HEADER = 'VINYLPAC-RAWBIN\n';
  var PARAMS = new URLSearchParams(location.search);
  var MODE = PARAMS.get('vpstandin') || '';
  var MODES = MODE.split(',');
  function mode(m) { return MODES.indexOf(m) !== -1; }
  var PAGE = window.VP_PAGE || (location.pathname.split('/').pop() || '').replace(/\.html$/, '');
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var THEME = !!window.VP_CDN;
  var HOLD_UNTIL = 0.35, LID_END = 2.55, HOLD_CAP = 0.8;   // the intro's own timing (jar-preview-3d.js knobs)
  var HOLD_BIG = 1.0, HOLD_MAX = 20;  // past the cap, keep the lid off while its frames would still come > 1 s late (slow links)
  var SLOW_RATE = 120000;             // bytes/s: below this the clip's own download is too slow to judge; the lid waits for all its bytes
  var SKIP_MAX = 0.25;          // a clip starting after its poster showed skips up to this much of the still opening hold
  var INTRO_TO = 2.75;          // clip seconds covered by the first (high priority) byte range
  var REBUFFER = 1.0;           // after a stall the clip resumes once this many seconds of frames are in
  var INTRO_WAIT = 2500;        // most ms the live jar's label art waits for the clip's opening bytes
  // The turn's bytes: 'high' shares the link with the live jar's art (the jar keeps turning; the live jar is ready a bit
  // later), 'low' waits behind it (the jar may pause, closed, until the live jar takes over). Tests: ?vpstandin=tailhigh|taillow
  var TAIL_PRIORITY = mode('taillow') ? 'low' : mode('tailhigh') ? 'high' : 'high';

  function mark(name, detail) {
    try { performance.mark(name, detail === undefined ? undefined : { detail: detail }); }
    catch (e) { try { performance.mark(name); } catch (ignored) {} }
  }
  function nowAbs() { return (performance.timeOrigin || 0) + performance.now(); }
  function absUrl(href) { try { return new URL(href, location.href).href; } catch (e) { return String(href); } }

  // Which hand-offs were verified: Chromium and WebKit (every iOS browser is WebKit). Others run live-only.
  function engine() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'webkit';
    if (/Firefox\//.test(ua)) return '';
    if (/Chrome\/|Chromium\/|Edg\//.test(ua)) return 'chromium';
    if (/AppleWebKit\//.test(ua) && /Safari\//.test(ua)) return 'webkit';
    return '';
  }
  var ENGINE = engine();

  function canvasPlayable() {
    try {
      return !!(window.Worker && window.OffscreenCanvas && window.VideoDecoder && window.EncodedVideoChunk && window.Blob &&
        window.URL && URL.createObjectURL && HTMLCanvasElement.prototype.transferControlToOffscreen);
    } catch (e) { return false; }
  }
  var PLAYER = mode('video') ? 'video' : canvasPlayable() ? 'canvas' : 'video';

  // ---- spec keys: one canonical form shared by the early guess, the decision and the renderer ----
  function keyOf(spec) {
    if (!spec || !spec.jar) return '';
    if (spec.labels === false) return 'jars|' + spec.jar + '|bare';
    return ['jl', spec.jar, spec.lidWrap ? 'wrap1' : 'wrap0', spec.material || 'gloss', spec.laminate || 'gloss',
      spec.emboss || 'none', spec.white || 'spot'].join('|');
  }
  function jarOf(key) { return String(key).split('|')[1] || ''; }

  // ---- the page's likely first jar, before the page script runs (only to start the downloads early) ----
  var LABEL_JARS = { 'miron-5ml-ceres': 1, 'miron-5ml-eris': 1, 'black-4oz': 1, 'miron-150ml': 1 };
  // Links from before the 10/17 split name jar=miron-5ml + jarType.
  function labelJarParam() { var j = PARAMS.get('jar'); return j === 'miron-5ml' ? (PARAMS.get('jarType') === 'Eris' ? 'miron-5ml-eris' : 'miron-5ml-ceres') : j; }
  var METALLIC = { Holographic: 'holo', Chrome: 'chrome', Gold: 'gold', Glitter: 'glitter' };
  function guessJarLabels() {
    if (PARAMS.has('edit') || PARAMS.has('openCart')) return null;
    if (PARAMS.has('variant') && !PARAMS.has('tier') && !PARAMS.has('finish') && !PARAMS.has('emboss')) return null;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('vp_jar_label_choices_v2') || 'null'); } catch (e) { cached = null; }
    var id = LABEL_JARS[labelJarParam()] ? labelJarParam() : cached && LABEL_JARS[cached.active] ? cached.active : 'miron-5ml-ceres';
    var saved = (cached && cached.choices && cached.choices[id]) || {};
    function pick(k, d) { return PARAMS.has(k) ? PARAMS.get(k) : typeof saved[k] === 'string' ? saved[k] : d; }
    var finish = pick('finish', 'Standard'), tier = pick('tier', 'Economical'), embossName = pick('emboss', 'No Embossing');
    var material = METALLIC[finish] || 'gloss';
    var whiteInk = PARAMS.has('whiteInk') ? PARAMS.get('whiteInk') : PARAMS.has('finish') ? 'No white' : typeof saved.whiteInk === 'string' ? saved.whiteInk : 'No white';
    // 10/15: the 4oz/150ml intro wears the Lid wrap unless the customer switched it themselves (jar-labels.js).
    var ring = true;
    if (cached && cached.lidWrapChosen === true && saved.ringChosen === true && typeof saved.ring === 'boolean') ring = saved.ring;
    if (PARAMS.has('lidWrap')) ring = PARAMS.get('lidWrap') === '1'; else if (PARAMS.get('ring') === '1') ring = true;
    var jar = id === 'black-4oz' ? 'black4oz' : id === 'miron-150ml' ? 'saturn' : id === 'miron-5ml-eris' ? 'eris' : 'ceres';
    return {
      jar: jar, labels: true, lidWrap: (jar === 'black4oz' || jar === 'saturn') && ring,
      material: material, laminate: embossName === 'Matte' ? 'matte' : 'gloss',
      emboss: tier === 'Premium Tier Embossing' ? 'heavy' : tier === 'Standard Tier Embossing' ? 'std' : 'none',
      white: material !== 'gloss' && whiteInk !== 'Spot white' ? 'none' : 'spot'
    };
  }
  var JARS_MODEL = { 'miron-ceres-5ml': 'ceres', 'miron-eris-5ml-cr': 'eris', 'black-glass-4oz-cr': 'black4oz', 'miron-saturn-150ml-cr': 'saturn' };
  function guessJars() {
    if (PARAMS.has('edit')) return null;
    var hash = '';
    try { hash = location.hash.indexOf('#jar-detail-') === 0 ? decodeURIComponent(location.hash.slice(12)) : ''; } catch (e) { hash = ''; }
    var first = 'miron-ceres-5ml';
    try {
      var cfg = JSON.parse(localStorage.getItem('vinylpac_jars') || 'null');
      if (cfg && cfg.products && cfg.products.length) first = cfg.products[0].id;
    } catch (e) {}
    var id = JARS_MODEL[hash] ? hash : JARS_MODEL[PARAMS.get('jar')] ? PARAMS.get('jar') : first;
    return JARS_MODEL[id] ? { jar: JARS_MODEL[id], labels: false } : null;
  }

  // The stage's CSS width for a viewport width (measured knots, linear between them).
  function predictStage(page) {
    var knots = DATA.layouts && DATA.layouts[page];
    if (!knots || !knots.length) return 0;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    if (vw <= knots[0][0]) return knots[0][1];
    for (var i = 1; i < knots.length; i++) {
      if (vw <= knots[i][0]) {
        var a = knots[i - 1], b = knots[i];
        return a[1] + (b[1] - a[1]) * (vw - a[0]) / (b[0] - a[0]);
      }
    }
    return knots[knots.length - 1][1];
  }

  // The clip made for this stage: the live canvas's own size (Safari: exactly; its scaling matches the canvas only
  // at the same pixel size), or in Chromium at most a few % larger (bigger renders draw thin linework darker), same aspect.
  // 10/12, measured with the canvas player too: a clip 0.2-0.6% larger than the canvas, scaled down, still shows its thin
  // dark lines ~5-9 levels lighter than the live jar in both engines, so Safari keeps exact sizes for both players.
  function backingOf(cssW) { return Math.floor(Math.round(cssW) * Math.min(window.devicePixelRatio || 1, 2)); }
  function tolerance() { return ENGINE === 'webkit' ? (DATA.toleranceWebkit || 1) : (DATA.tolerance || 1.045); }
  function pickBucket(entry, cssW, cssH) {
    var w = Math.round(cssW), h = Math.round(cssH);
    if (!(w > 0 && h > 0) || Math.abs(w / h - entry.aspect) > entry.aspect * 0.005) return null;
    var backing = backingOf(w);
    var best = null, tol = tolerance();
    (entry.buckets || []).forEach(function (b) {
      var r = b.size / backing;
      if (r >= 1 && r <= tol && (!best || b.size < best.size)) best = b;
    });
    return best;
  }

  var probeVideo = null;
  function canPlay(codec) {
    try {
      probeVideo = probeVideo || document.createElement('video');
      return /^(probably|maybe)$/.test(probeVideo.canPlayType('video/mp4; codecs="' + codec + '"'));
    } catch (e) { return false; }
  }

  function usable(entry) {
    return !!entry && entry.page === PAGE && (entry.engines || []).indexOf(ENGINE) !== -1;
  }

  // ---- local preview only: the stand-ins daemon (tools/standins, every ~15 s) lists the clips whose inputs still hash to
  // their fingerprint. The theme build runs the same check before shipping, so the theme never needs this. ----
  var fresh = null, freshWaiters = [];
  function loadFresh() {
    if (THEME || fresh) return;
    fresh = { pending: true };
    var url = ['tools', 'standins', 'out', 'fresh.json'].join('/');   // built at run time: never shipped with the theme
    var finished = false, timer;
    var done = function (j) {
      if (finished) return;
      finished = true; clearTimeout(timer);
      fresh = j && j.entries ? j : { bad: true };
      var w = freshWaiters; freshWaiters = [];
      w.forEach(function (cb) { try { cb(); } catch (e) {} });
    };
    timer = setTimeout(function () { done(null); }, INTRO_WAIT);
    fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(done, function () { done(null); });
  }
  function freshness(key, entry) {
    if (THEME) return '';
    if (!fresh) loadFresh();
    if (fresh.pending) return 'fresh-pending';
    if (fresh.bad || !(Math.abs(Date.now() - fresh.t) < 90000)) return 'fresh-unknown';
    return fresh.entries[key] === entry.fp ? '' : 'stale';
  }
  function whenFresh(cb) { if (fresh && !fresh.pending) cb(); else freshWaiters.push(cb); }

  // ---- bytes: posters, stills and thumbnails ship as .bin (Shopify re-encodes images); clips stream ----
  var fetches = {};
  function fetchBin(url, priority) {
    if (!fetches[url]) {
      var init = { credentials: 'same-origin' };
      try { init.priority = priority || 'high'; } catch (e) {}
      fetches[url] = fetch(url, init).then(function (r) {
        if (!r.ok) throw new Error('standin ' + r.status);
        return r.arrayBuffer();
      }).then(function (buf) {
        var head = new Uint8Array(buf, 0, Math.min(16, buf.byteLength)), text = '';
        for (var i = 0; i < head.length; i++) text += String.fromCharCode(head[i]);
        return text === RAW_HEADER ? buf.slice(16) : buf;
      });
      var pending = fetches[url];
      pending.catch(function () { if (fetches[url] === pending) delete fetches[url]; });
    }
    return fetches[url];
  }
  function blobUrl(url, type) {
    return fetchBin(url).then(function (buf) { return URL.createObjectURL(new Blob([buf], { type: type })); });
  }
  function thumbUrls(url) {
    return fetchBin(url, 'low').then(function (buf) {
      var view = new DataView(buf), out = [], at = 0;
      while (at + 4 <= buf.byteLength && out.length < 3) {
        var n = view.getUint32(at); at += 4;
        if (!n || at + n > buf.byteLength) { out.forEach(function (u) { URL.revokeObjectURL(u); }); throw new Error('standin thumbs'); }
        out.push(URL.createObjectURL(new Blob([buf.slice(at, at + n)], { type: 'image/jpeg' })));
        at += n;
      }
      if (out.length !== 3 || at !== buf.byteLength) { out.forEach(function (u) { URL.revokeObjectURL(u); }); throw new Error('standin thumbs'); }
      return out;
    });
  }

  // ================================================================ canvas player (worker)
  // Runs in a worker (source via Function#toString). Protocol, in: load / canvas / play / shown / pause / resume / stop;
  // out: requested, meta, first, frame, stall, unstall, hold, unhold, ended, paused, fail.
  function clipWorker() {
    'use strict';
    var S = null;
    function post(m) { try { self.postMessage(m); } catch (e) {} }
    function absNow() { return (performance.timeOrigin || 0) + performance.now(); }
    function fail(why) { if (!S || S.failed) return; S.failed = true; post({ ev: 'fail', why: String((why && why.message) || why), shown: S.shown }); stop(); }
    function u32(b, i) { return ((b[i] << 24) >>> 0) + (b[i + 1] << 16) + (b[i + 2] << 8) + b[i + 3]; }
    function boxes(b, a, z, cb) {
      var i = a;
      while (i + 8 <= z) {
        var size = u32(b, i), hdr = 8, type = String.fromCharCode(b[i + 4], b[i + 5], b[i + 6], b[i + 7]);
        if (size === 1) { size = u32(b, i + 8) * 4294967296 + u32(b, i + 12); hdr = 16; }
        else if (size === 0) size = z - i;
        if (size < hdr) return;
        if (cb(type, i + hdr, i + size) === false) return;
        i += size;
      }
    }
    function child(b, a, z, path) {
      var hit = null;
      boxes(b, a, z, function (t, s, e) { if (t === path[0]) { hit = [s, e]; return false; } });
      if (!hit) return null;
      return path.length === 1 ? hit : child(b, hit[0], hit[1], path.slice(1));
    }
    // The sample table of the (only) video track: offset, size, key flag and frame index in presentation order.
    function parseMoov(b, a, z, fps) {
      var trak = child(b, a, z, ['trak']);
      if (!trak) throw new Error('no trak');
      var mdhd = child(b, trak[0], trak[1], ['mdia', 'mdhd']);
      var timescale = b[mdhd[0]] === 1 ? u32(b, mdhd[0] + 20) : u32(b, mdhd[0] + 12);
      var stbl = child(b, trak[0], trak[1], ['mdia', 'minf', 'stbl']);
      function box(name) { return child(b, stbl[0], stbl[1], [name]); }
      var stsd = box('stsd'), avcC = null, w = 0, h = 0;
      boxes(b, stsd[0] + 8, stsd[1], function (t, s, e) {
        if (t !== 'avc1' && t !== 'avc3') return;
        w = (b[s + 24] << 8) | b[s + 25]; h = (b[s + 26] << 8) | b[s + 27];
        var c = child(b, s + 78, e, ['avcC']);
        if (c) avcC = b.slice(c[0], c[1]);
        return false;
      });
      if (!avcC || !timescale) throw new Error('no avcC');
      var dts = [], t = 0, x = box('stts'), n, i, j;
      n = u32(b, x[0] + 4);
      for (i = 0; i < n; i++) { var c1 = u32(b, x[0] + 8 + 8 * i), d1 = u32(b, x[0] + 12 + 8 * i); for (j = 0; j < c1; j++) { dts.push(t); t += d1; } }
      var N = dts.length, cts = new Array(N).fill(0);
      x = box('ctts');
      if (x) {
        var ver = b[x[0]], at = 0; n = u32(b, x[0] + 4);
        for (i = 0; i < n; i++) {
          var c2 = u32(b, x[0] + 8 + 8 * i), o = u32(b, x[0] + 12 + 8 * i);
          if (ver === 1 && o > 0x7fffffff) o -= 4294967296;
          for (j = 0; j < c2 && at < N; j++) cts[at++] = o;
        }
      }
      var key = null;
      x = box('stss');
      if (x) { key = new Uint8Array(N); n = u32(b, x[0] + 4); for (i = 0; i < n; i++) key[u32(b, x[0] + 8 + 4 * i) - 1] = 1; }
      x = box('stsz');
      var fixed = u32(b, x[0] + 4), count = u32(b, x[0] + 8), sizes = [];
      for (i = 0; i < count; i++) sizes.push(fixed || u32(b, x[0] + 12 + 4 * i));
      x = box('stsc');
      var stsc = []; n = u32(b, x[0] + 4);
      for (i = 0; i < n; i++) stsc.push([u32(b, x[0] + 8 + 12 * i), u32(b, x[0] + 12 + 12 * i)]);
      var co = [];
      x = box('stco');
      if (x) { n = u32(b, x[0] + 4); for (i = 0; i < n; i++) co.push(u32(b, x[0] + 8 + 4 * i)); }
      else { x = box('co64'); n = u32(b, x[0] + 4); for (i = 0; i < n; i++) co.push(u32(b, x[0] + 8 + 8 * i) * 4294967296 + u32(b, x[0] + 12 + 8 * i)); }
      var offs = [], s = 0;
      for (i = 0; i < co.length && s < N; i++) {
        var per = 0;
        for (j = stsc.length - 1; j >= 0; j--) if (stsc[j][0] <= i + 1) { per = stsc[j][1]; break; }
        var off = co[i];
        for (var q = 0; q < per && s < N; q++) { offs.push(off); off += sizes[s]; s++; }
      }
      if (offs.length !== N || sizes.length !== N) throw new Error('sample table');
      var p0 = Infinity;
      for (i = 0; i < N; i++) p0 = Math.min(p0, dts[i] + cts[i]);
      var samples = [];
      for (i = 0; i < N; i++) {
        var pts = (dts[i] + cts[i] - p0) / timescale, next = i + 1 < N ? dts[i + 1] : dts[i] + (i ? dts[i] - dts[i - 1] : 0);
        samples.push({ off: offs[i], size: sizes[i], key: key ? !!key[i] : true, k: Math.round(pts * fps),
                       us: Math.round(pts * 1e6), dur: Math.max(0, Math.round((next - dts[i]) / timescale * 1e6)) });
      }
      return { avcC: avcC, w: w, h: h, samples: samples };
    }
    function stop() {
      if (!S) return;
      S.stopped = true;
      try { S.abort.abort(); } catch (e) {}
      try { S.tailAbort.abort(); } catch (e) {}
      try { if (S.dec && S.dec.state !== 'closed') S.dec.close(); } catch (e) {}
      S.frames.forEach(function (f) { try { f.close(); } catch (e) {} });
      S.frames.clear();
      if (S.timer) { try { (self.cancelAnimationFrame || clearTimeout)(S.timer); } catch (e) {} S.timer = 0; }
    }
    function feed() {
      if (!S || S.stopped || !S.meta || !S.dec || S.dec.state !== 'configured') return;
      var sm = S.meta.samples;
      while (S.next < sm.length) {
        var x = sm[S.next];
        if (x.off + x.size > S.got) break;
        if (S.frames.size + S.dec.decodeQueueSize >= S.ahead) break;
        try { S.dec.decode(new EncodedVideoChunk({ type: x.key ? 'key' : 'delta', timestamp: x.us, duration: x.dur, data: S.buf.subarray(x.off, x.off + x.size) })); }
        catch (e) { fail(e); return; }
        S.next++;
      }
      // All fed, or no more bytes will come (a cut-off download): flush, so the frames still in the decoder come out.
      var end = S.next >= sm.length || (S.dataEnd && sm[S.next].off + sm[S.next].size > S.got);
      if (end && !S.flushed) { S.flushed = true; S.dec.flush().then(function () {}, function () {}); }
    }
    function onFrame(f) {
      if (!S || S.stopped) { f.close(); return; }
      var k = Math.round(f.timestamp * S.fps / 1e6);
      if (k <= S.shown || S.frames.has(k) || k >= S.n) { f.close(); return; }
      S.frames.set(k, f);
      schedule();
    }
    function draw(k) {
      var f = S.frames.get(k);
      if (!f || !S.ctx) return false;
      S.ctx.drawImage(f, 0, 0, S.canvas.width, S.canvas.height);
      // The canvas keeps the pixels: this frame and any skipped before it are not needed again.
      S.frames.forEach(function (g, j) { if (j <= k) { g.close(); S.frames.delete(j); } });
      S.shown = k;
      return true;
    }
    // Would the frames from clip time `from` to `to` arrive before they are due, at the rate the clip has been arriving?
    // (Decode order is file order: frame k needs every byte up to S.need[k].)
    // Download rate: the last second's when there is one (the link frees up as the page's other files finish, so the
    // average since the first byte undersells it), else the average.
    function avgRate() {
      var el = (performance.now() - S.firstByteAt) / 1000;
      return el > 0.1 ? (S.got - S.firstBytes) / el : 0;
    }
    function rate() {
      var now = performance.now(), avg = avgRate();
      var w = S.samples, i = 0;
      while (i < w.length - 1 && now - w[i][0] > 1000) i++;
      var span = w.length ? (now - w[i][0]) / 1000 : 0;
      var recent = span >= 0.4 ? (S.got - w[i][1]) / span : 0;
      return Math.max(avg, recent);
    }
    // How late (s) the most delayed frame between `from` and `to` would be if playback went on from `from` now.
    function shortfall(from, to) {
      if (S.got >= S.total) return 0;
      var rate_ = rate(), worst = 0;
      var a = Math.max(0, Math.ceil(from * S.fps)), z = Math.min(S.n - 1, Math.floor(to * S.fps));
      for (var k = a; k <= z; k++) {
        var missing = S.need[k] - S.got;
        if (missing > 0) worst = Math.max(worst, rate_ > 0 ? missing / rate_ - (k / S.fps - from) : Infinity);
      }
      return worst;
    }
    function late(from, to) { return shortfall(from, to) > 0; }
    // Bytes for every frame up to clip time `to` are in (or the whole clip is).
    function buffered(to) { return S.got >= S.total || S.need[Math.min(S.n - 1, Math.floor(to * S.fps))] <= S.got; }
    function schedule() {
      if (!S || S.stopped || S.timer || !S.playing || S.paused) return;
      if (self.requestAnimationFrame) S.timer = self.requestAnimationFrame(function () { S.timer = 0; tick(); });
      else S.timer = setTimeout(function () { S.timer = 0; tick(); }, 8);
    }
    function tick() {
      if (!S || S.stopped || S.failed) return;
      var now = performance.now();
      feed();
      if (S.paused || !S.playing || !S.ctx) return;
      if (S.shown < 0) {
        // Started after the poster showed: skip that much of the still opening hold (never into the lid).
        var skip = S.shownAt ? Math.max(0, Math.min(S.skipMax, (absNow() - S.shownAt) / 1000)) : 0, k0 = Math.round(skip * S.fps);
        var ok0 = true;
        for (var i = 0; i <= k0; i++) if (!S.frames.has(i)) { ok0 = i > 0; k0 = i - 1; break; }
        if (!ok0 || !draw(k0)) return;      // waits for frame 0 (a decoded frame wakes the loop)
        S.clock = k0 / S.fps; S.last = now;
        post({ ev: 'first', k: k0, at: absNow() });
      } else if (S.shown < S.n - 1) {
        var dt = Math.min(0.1, (now - S.last) / 1000), want = S.clock + dt;
        S.last = now;
        // Elastic hold: the opening hold (lid off, nothing moves) lasts until the lid's frames can play through, up to a
        // cap; on a link so slow that the lid would still come seconds late, it waits for them (a half-screwed lid
        // standing still looks broken; a jar waiting with its lid off doesn't), up to holdMax.
        // On a very slow link (the clip's own bytes averaging under slowRate) a projection can be fooled by a burst: there
        // the lid waits until every byte of the lid is in.
        if (S.holdUntil && !S.holdDone && want * S.fps >= S.holdUntil * S.fps - 0.5) {
          var slow = S.got < S.total && avgRate() < S.slowRate;
          var short = slow ? (buffered(S.lidEnd) ? 0 : Infinity) : shortfall(S.holdUntil, S.lidEnd);
          if (short > 0 && (S.heldFor < S.holdCap || (short > S.holdBig && S.heldFor < S.holdMax))) {
            S.heldFor += dt; want = S.clock;
            if (!S.holding) { S.holding = true; post({ ev: 'hold', k: S.shown }); }
          } else {
            S.holdDone = true;
            if (S.holding) { S.holding = false; post({ ev: 'unhold', ms: Math.round(S.heldFor * 1000) }); }
          }
        }
        var k = Math.min(S.n - 1, Math.round(want * S.fps));
        // After a stall the clip waits until the next REBUFFER s of frames are in (during the lid: all of the lid), so it
        // resumes smoothly once instead of stuttering through every late chunk.
        if (S.stalled && !buffered(S.clock < S.lidEnd ? Math.max(S.lidEnd, S.clock + S.rebuffer) : S.clock + S.rebuffer)) k = S.shown;
        if (k > S.shown) {
          var ok = true;
          for (var j = S.shown + 1; j <= k; j++) if (!S.frames.has(j)) { ok = false; break; }
          if (ok) {
            draw(k); S.clock = want;
            if (S.stalled) { S.stalled = false; post({ ev: 'unstall', k: k }); }
            post({ ev: 'frame', k: k, at: absNow() });
            if (k === S.n - 1) { S.ended = true; post({ ev: 'ended', k: k }); }
          } else if (!S.stalled) { S.stalled = true; post({ ev: 'stall', k: S.shown }); }
        } else if (!S.stalled) {
          S.clock = want;
        }
      }
      if (!S.ended) schedule();
    }
    function chunkInto(v, at) {
      if (at + v.length > S.buf.length) { var nb = new Uint8Array(Math.max(S.buf.length * 2, at + v.length)); nb.set(S.buf); S.buf = nb; }
      S.buf.set(v, at);
    }
    // One byte range (or the whole file) into the buffer, streamed. Ranges are read in file order, so `got` stays contiguous.
    async function read(range, priority, signal) {
      var init = { credentials: 'same-origin', signal: signal || S.abort.signal }, r, net = { range: range ? range.join('-') : 'all', t0: absNow() };
      S.net.push(net);
      if (priority) init.priority = priority;
      if (range) init.headers = { Range: 'bytes=' + range[0] + '-' + (range[1] >= 0 ? range[1] : '') };
      r = await fetch(S.url, init);
      net.tb = absNow();
      if (S.stopped) return 'stopped';
      if (!r.ok) throw new Error('clip ' + r.status);
      var at = 0, whole = r.status !== 206;
      if (!whole) {
        var m = /bytes (\d+)-(\d+)\/(\d+)/.exec(r.headers.get('content-range') || '');
        if (!m || +m[1] !== range[0]) throw new Error('clip range');
        at = +m[1]; S.total = +m[3];
      } else {
        S.total = +r.headers.get('content-length') || S.total;
        if (S.got) { S.got = 0; }   // a server without ranges sent the whole file again: take it from the start
      }
      if (S.total > S.buf.length) { var nb = new Uint8Array(S.total); nb.set(S.buf.subarray(0, S.got)); S.buf = nb; }
      var reader = r.body.getReader();
      for (;;) {
        var c = await reader.read();
        if (S.stopped) return 'stopped';
        if (c.done) break;
        if (!S.firstByteAt) { S.firstByteAt = performance.now(); S.firstBytes = c.value.length; }
        chunkInto(c.value, at); at += c.value.length;
        if (at > S.got) S.got = at;
        var tn = performance.now();
        S.samples.push([tn, S.got]);
        while (S.samples.length > 2 && tn - S.samples[1][0] > 1500) S.samples.shift();
        if (!S.meta) await meta();
        feed();
      }
      if (whole) S.total = S.got;
      net.te = absNow(); net.bytes = at - (range && !whole ? range[0] : 0);
      return whole ? 'whole' : 'range';
    }
    async function load() {
      try {
        var split = S.intro > 0 && S.bytes > S.intro + 1;
        var first = read(split ? [0, S.intro] : null, 'high');
        post({ ev: 'requested' });
        var how = await first;
        if (how === 'stopped') return;
        S.introPosted = true;
        post({ ev: 'intro', net: S.net });   // the opening's bytes are in: the live jar's label art may come now
        if (how === 'range' && S.got < S.total && !S.noTail) {
          // The rest of the clip (the turn), sharing the link with the live jar's label art (S.tail: 'high'), or after it ('low').
          if ((await read([S.got, -1], S.tail || 'high', S.tailAbort.signal)) === 'stopped') return;
        }
        if (S.noTail && S.got < S.total) throw new Error('turn not needed');
        if (!S.meta) throw new Error('no moov');
        if (S.got < S.total) throw new Error('clip short');
      } catch (e) {
        if (S.stopped) return;
        if (!S.introPosted) { S.introPosted = true; post({ ev: 'intro', net: S.net }); }
        // Nothing playable yet: the page falls back to its other player. Otherwise what arrived plays and the clip
        // then holds its last frame (a stall: the live jar takes over on it).
        if (!S.meta || !S.dec) { fail(e); return; }
        post({ ev: 'short', why: String((e && e.message) || e) });
      }
      S.dataEnd = true;
      post({ ev: 'loaded', net: S.net });
      feed();
    }
    async function meta() {
      if (S.meta || S.metaBusy) return;
      var b = S.buf, moov = null;
      boxes(b, 0, S.got, function (t, s, e) { if (t === 'moov') { moov = [s, e]; return false; } if (t === 'mdat') return false; });
      if (!moov || moov[1] > S.got) return;
      S.metaBusy = true;
      var m;
      try { m = parseMoov(b, moov[0], moov[1], S.fps); } catch (e) { fail(e); return; }
      if (m.samples.length !== S.n) { fail('frames ' + m.samples.length + '/' + S.n); return; }
      var cfg = { codec: S.codec, codedWidth: m.w, codedHeight: m.h, description: m.avcC, optimizeForLatency: true };
      try {
        var sup = await VideoDecoder.isConfigSupported(cfg);
        if (S.stopped) return;
        if (!sup || !sup.supported) { fail('unsupported ' + S.codec); return; }
        S.dec = new VideoDecoder({ output: onFrame, error: function (e) { fail(e); } });
        S.dec.configure(cfg);
      } catch (e) { fail(e); return; }
      S.need = new Array(S.n).fill(0);
      m.samples.forEach(function (x) { if (x.k >= 0 && x.k < S.n) S.need[x.k] = Math.max(S.need[x.k], x.off + x.size); });
      for (var i = 1; i < S.n; i++) S.need[i] = Math.max(S.need[i], S.need[i - 1]);
      S.meta = m;
      post({ ev: 'meta' });
      feed();
    }
    self.onmessage = function (e) {
      var m = e.data || {};
      if (m.op === 'load') {
        S = { url: m.url, fps: m.fps, n: m.frames, codec: m.codec, intro: m.intro || 0, bytes: m.bytes || 0, total: m.bytes || 0,
              holdUntil: m.holdUntil || 0, lidEnd: m.lidEnd || 0, holdCap: m.holdCap || 0, heldFor: 0, skipMax: m.skipMax || 0,
              holdBig: m.holdBig || 1, holdMax: m.holdMax || 0, slowRate: m.slowRate || 0,
              rebuffer: m.rebuffer || 1, tail: m.tail || 'high', tailAbort: new AbortController(), noTail: false,
              ahead: m.ahead || 24, abort: new AbortController(), buf: new Uint8Array(m.bytes || 1 << 20), got: 0, next: 0, net: [], samples: [],
              shown: -1, frames: new Map(), playing: false, paused: false, ctx: null, canvas: null };
        load();
      } else if (!S) {
        return;
      } else if (m.op === 'canvas') {
        S.canvas = m.canvas;
        // Transparent until frame 0 is drawn (an opaque context would show black over the poster first).
        try { S.ctx = S.canvas.getContext('2d'); } catch (err) { S.ctx = null; }
        if (!S.ctx) { fail('no 2d context'); return; }
        S.ctx.imageSmoothingEnabled = true; S.ctx.imageSmoothingQuality = 'high';
        schedule();
      } else if (m.op === 'play') {
        S.playing = true; S.last = performance.now(); schedule();
      } else if (m.op === 'shown') {
        if (S.shown < 0 && !S.shownAt) S.shownAt = m.at;
      } else if (m.op === 'pause') {
        // A passive hand-off was decided on the frame the page last heard of; this thread may have drawn more since.
        // 'calm': only inside a calm window (or before the first frame); 'stopped': only while the clip isn't advancing.
        var t = S.shown / S.fps, still = !!S.ended || !!S.stalled || !!S.holding || S.shown < 0;
        var calm = S.shown < 0 || (m.calm || []).some(function (w) { return t >= w[0] && t < w[1]; });
        if ((m.when === 'calm' && !calm) || (m.when === 'stopped' && !still && !calm)) {
          post({ ev: 'paused', id: m.id, refused: true, k: S.shown });
          return;
        }
        S.paused = true;
        if (S.timer) { try { (self.cancelAnimationFrame || clearTimeout)(S.timer); } catch (err) {} S.timer = 0; }
        post({ ev: 'paused', id: m.id, k: S.shown, ended: !!S.ended, stopped: still });
      } else if (m.op === 'resume') {
        S.paused = false; S.last = performance.now(); schedule();
      } else if (m.op === 'notail') {
        // The page asked for the live jar (a touch, a view, another finish): the turn's bytes would only slow it down.
        S.noTail = true;
        try { S.tailAbort.abort(); } catch (err) {}
      } else if (m.op === 'stop') {
        stop();
      }
    };
  }

  // Every frame the canvas player drew: [page time, page time, clip seconds, count] (the shape of a video frame
  // callback's data, so the same analysis reads both). Kept after the hand-off for measurements (VPStandin.frames()).
  var frameLog = [];
  function logFrame(m, fps) {
    if (frameLog.length >= 2000 || !m.at) return;
    var t = Math.round((m.at - (performance.timeOrigin || 0)) * 10) / 10;
    frameLog.push([t, t, Math.round(m.k / fps * 1e4) / 1e4, frameLog.length + 1]);
  }

  var workerUrl = null;
  function newWorker() {
    if (!workerUrl) workerUrl = URL.createObjectURL(new Blob(['(' + clipWorker.toString() + ')();'], { type: 'text/javascript' }));
    return new Worker(workerUrl);
  }

  function CanvasPlayer(bucket, entry) {
    var p = this;
    p.kind = 'canvas'; p.bucket = bucket; p.entry = entry;
    p.started = false; p.moved = false; p.ended = false; p.stalled = false; p.stallAt = 0; p.holding = false; p.failed = false;
    p.k = -1; p.frames = 0; p.stalls = 0; p.stallMs = 0; p.maxStallMs = 0; p.heldMs = 0; p.seq = 0; p.cbs = {};
    p.onrequested = null; p.onfirst = null; p.onmoved = null; p.onfail = null;
    try {
      p.w = newWorker();
    } catch (e) { p.w = null; p.failed = true; p.why = 'worker'; return; }
    p.w.onmessage = function (e) { p.msg(e.data || {}); };
    p.w.onerror = function () { p.fail('worker error'); };
    p.w.postMessage({ op: 'load', url: absUrl(bucket.clip), fps: entry.fps, frames: entry.frames, codec: bucket.codec,
      intro: bucket.intro || 0, bytes: bucket.bytes || 0, holdUntil: HOLD_UNTIL, lidEnd: LID_END, holdCap: HOLD_CAP, skipMax: SKIP_MAX,
      holdBig: HOLD_BIG, holdMax: HOLD_MAX, slowRate: SLOW_RATE,
      rebuffer: REBUFFER, tail: TAIL_PRIORITY });
  }
  CanvasPlayer.prototype.mount = function (root, w, h) {
    if (this.failed || this.el) return;
    var c = this.el = document.createElement('canvas');
    c.width = w; c.height = h;
    c.setAttribute('aria-hidden', 'true');
    root.appendChild(c);
    try {
      var off = c.transferControlToOffscreen();
      this.w.postMessage({ op: 'canvas', canvas: off }, [off]);
    } catch (e) { this.fail('transfer'); }
  };
  CanvasPlayer.prototype.play = function () { if (this.w && !this.failed) this.w.postMessage({ op: 'play' }); };
  CanvasPlayer.prototype.shown = function (at) { if (this.w && !this.failed) this.w.postMessage({ op: 'shown', at: at }); };
  CanvasPlayer.prototype.msg = function (m) {
    var p = this, now = performance.now();
    if (m.ev === 'requested') { if (p.onrequested) p.onrequested(); }
    else if (m.ev === 'first') { p.started = true; p.k = m.k; logFrame(m, p.entry.fps); if (p.onfirst) p.onfirst(); }
    else if (m.ev === 'frame') {
      p.k = m.k; p.frames++; logFrame(m, p.entry.fps);
      if (!p.moved) { p.moved = true; if (p.onmoved) p.onmoved(); }
    }
    else if (m.ev === 'stall') { p.stalled = true; p.stallAt = now; p.stalls++; mark('vp:standin-stall', { k: m.k }); }
    else if (m.ev === 'unstall') {
      var ms = p.stallAt ? now - p.stallAt : 0;
      p.stallMs += ms; p.maxStallMs = Math.max(p.maxStallMs, ms); p.stalled = false; p.stallAt = 0;
      mark('vp:standin-unstall', { k: m.k, ms: Math.round(ms) });
    }
    else if (m.ev === 'hold') { p.holding = true; mark('vp:standin-hold', { k: m.k }); }
    else if (m.ev === 'unhold') { p.holding = false; p.heldMs = m.ms; mark('vp:standin-unhold', { ms: m.ms }); }
    else if (m.ev === 'ended') { p.ended = true; p.k = m.k; }
    else if (m.ev === 'short') { mark('vp:standin-short', { why: m.why }); }
    else if (m.ev === 'intro') { p.net = m.net; mark('vp:standin-intro'); p.introDone(); }
    else if (m.ev === 'loaded') { p.net = m.net; mark('vp:standin-loaded'); }
    else if (m.ev === 'paused') { var cb = p.cbs[m.id]; delete p.cbs[m.id]; if (cb) cb(m.refused ? null : m.k >= 0 ? m.k : 0, m.stopped); }
    else if (m.ev === 'fail') { if (m.shown >= 0) p.k = m.shown; p.fail(m.why); }
  };
  // The live jar's label art waits for the clip's opening bytes (VPStandin.introLoaded): both are big, and sharing the
  // link the lid stalled on phones while the art loaded no sooner overall.
  CanvasPlayer.prototype.introDone = function () {
    this.introIn = true;
    var w = this.introWaiters || []; this.introWaiters = [];
    w.forEach(function (cb) { try { cb(); } catch (e) {} });
  };
  CanvasPlayer.prototype.fail = function (why) {
    if (this.failed) return;
    this.introDone();
    this.failed = true; this.why = String(why || '');
    var cbs = this.cbs, k = Math.max(0, this.k), started = this.started;
    this.cbs = {};
    Object.keys(cbs).forEach(function (id) { cbs[id](k, true); });
    if (this.w) { try { this.w.terminate(); } catch (e) {} this.w = null; }
    if (this.onfail) this.onfail(this.why, started);
  };
  CanvasPlayer.prototype.time = function () { return Math.max(0, this.k) / this.entry.fps; };
  CanvasPlayer.prototype.stopped = function (now) { return this.ended || this.holding || this.failed || (this.stalled && now - this.stallAt > 250); };
  CanvasPlayer.prototype.pause = function (cb, when) {
    var p = this;
    if (p.failed || !p.w) { cb(p.started ? Math.max(0, p.k) : 0, true); return; }
    var id = ++p.seq;
    p.cbs[id] = cb;
    p.w.postMessage({ op: 'pause', id: id, when: when || 'now', calm: p.entry.calm || [] });
    // A worker that never answers (crashed) can't be drawing either: its last reported frame is on screen.
    setTimeout(function () { if (p.cbs[id]) { delete p.cbs[id]; cb(p.started ? Math.max(0, p.k) : 0, true); } }, 1500);
  };
  CanvasPlayer.prototype.resume = function () { if (this.w && !this.failed) this.w.postMessage({ op: 'resume' }); };
  CanvasPlayer.prototype.dropTail = function () { if (this.w && !this.failed && !this.tailDropped) { this.tailDropped = true; this.w.postMessage({ op: 'notail' }); } };
  CanvasPlayer.prototype.kill = function () {
    this.introDone();
    this.cbs = {}; this.onfail = this.onfirst = this.onmoved = this.onrequested = null;
    if (this.w) { try { this.w.postMessage({ op: 'stop' }); this.w.terminate(); } catch (e) {} this.w = null; }
  };
  CanvasPlayer.prototype.stats = function () {
    var to = performance.timeOrigin || 0, rel = function (x) { return x ? Math.round(x - to) : null; };
    return { kind: 'canvas', k: this.k, frames: this.frames, stalls: this.stalls, stallMs: Math.round(this.stallMs), maxStallMs: Math.round(this.maxStallMs),
      heldMs: this.heldMs, holding: this.holding, stalled: this.stalled, ended: this.ended, failed: this.failed ? this.why || true : false,
      net: (this.net || []).map(function (n) { return { range: n.range, start: rel(n.t0), firstByte: rel(n.tb), end: rel(n.te), bytes: n.bytes || null }; }) };
  };

  // ================================================================ <video> player (no WebCodecs/OffscreenCanvas)
  function VideoPlayer(bucket, entry) {
    var p = this;
    p.kind = 'video'; p.bucket = bucket; p.entry = entry;
    p.started = false; p.moved = false; p.ended = false; p.playing = false; p.stalledAt = 0; p.blocked = false; p.failed = false;
    p.onfirst = null; p.onmoved = null; p.onfail = null; p.onblocked = null; p.stalls = 0;
    var v = p.v = p.el = document.createElement('video');
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto'; v.loop = false;
    ['muted', 'playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
    v.setAttribute('aria-hidden', 'true');
    v.tabIndex = -1;
    if (THEME) {
      v.src = bucket.clip;   // Shopify's CDN serves theme mp4s byte-exact with ranges: it plays as it downloads
    } else {
      // Local preview (serve.py has no byte ranges, which Safari needs for video): play it from memory.
      var init = { credentials: 'same-origin' };
      try { init.priority = 'high'; } catch (e) {}
      fetch(bucket.clip, init).then(function (r) { if (!r.ok) throw new Error('clip ' + r.status); return r.blob(); })
        .then(function (blob) {
          if (p.dead) return;
          v.src = URL.createObjectURL(blob);
          if (p.wantPlay) p.playNow();
        })
        .catch(function () { p.fail('fetch'); });
    }
    var first = function () {
      if (p.started || p.dead) return;
      p.started = true;
      if (p.onfirst) p.onfirst();
    };
    if (typeof v.requestVideoFrameCallback === 'function') v.requestVideoFrameCallback(first);
    v.addEventListener('playing', function () {
      p.playing = true; p.stalledAt = 0; p.blocked = false;   // a refused play() that ran anyway (autoplay) clears the block
      if (typeof v.requestVideoFrameCallback !== 'function') first();
    });
    v.addEventListener('timeupdate', function () {
      p.stalledAt = 0;
      if (v.currentTime > 0) { first(); if (!p.moved) { p.moved = true; if (p.onmoved) p.onmoved(); } }
    });
    v.addEventListener('waiting', function () { if (p.started && !p.stalledAt) { p.stalledAt = performance.now(); p.stalls++; } });
    v.addEventListener('ended', function () { p.ended = true; });
    v.addEventListener('error', function () { p.fail('error'); });
  }
  VideoPlayer.prototype.mount = function (root) { root.appendChild(this.v); };
  VideoPlayer.prototype.play = function () { this.wantPlay = true; if (this.v.getAttribute('src')) this.playNow(); };
  VideoPlayer.prototype.shown = function () {};
  VideoPlayer.prototype.playNow = function () {
    var p = this, v = p.v, r;
    try { r = v.play(); } catch (e) { r = null; p.block(e); }
    if (r && typeof r.then === 'function') r.then(null, function (error) { if (!(error && error.name === 'AbortError')) p.block(error); });
  };
  VideoPlayer.prototype.block = function (error) {
    // iOS Low Power Mode (or another autoplay block) refuses the play() of any video.
    if (this.dead || this.playing) return;
    this.blocked = true;
    mark('vp:standin-miss', { reason: 'play-blocked', name: error && error.name });
    if (this.onblocked) this.onblocked();
  };
  VideoPlayer.prototype.fail = function (why) {
    if (this.failed || this.dead) return;
    this.failed = true; this.why = why;
    mark('vp:standin-miss', { reason: 'clip-error', why: why });
    if (this.onfail) this.onfail(why, this.started);
  };
  // The frame on screen: the media clock is right even after long main-thread tasks (a frame callback's time can lag).
  VideoPlayer.prototype.frame = function () {
    var v = this.v, fps = this.entry.fps, n = this.entry.frames;
    if (!(v.currentTime > 0) && !this.started) return 0;
    return this.ended || v.ended || v.currentTime >= (n - 1) / fps ? n - 1 : Math.max(0, Math.floor(v.currentTime * fps + 1e-3));
  };
  VideoPlayer.prototype.time = function () { return this.v.currentTime || 0; };
  VideoPlayer.prototype.stopped = function (now) {
    var v = this.v;
    return this.ended || v.ended || this.failed || this.blocked || (this.stalledAt && now - this.stalledAt > 250) || (v.paused && !v.ended && this.playing);
  };
  VideoPlayer.prototype.pause = function (cb) {   // decided on the media clock itself: no stale frame to re-check
    var stopped = !this.started || this.stopped(performance.now());
    try { this.v.pause(); } catch (e) {}
    cb(this.frame(), stopped);
  };
  VideoPlayer.prototype.resume = function () { if (!this.dead && !this.ended && !this.blocked && !this.failed) this.playNow(); };
  VideoPlayer.prototype.kill = function () {
    var v = this.v;
    this.dead = true; this.onfirst = this.onmoved = this.onfail = this.onblocked = null;
    try { v.pause(); } catch (e) {}
    var src = v.currentSrc || v.src;
    v.removeAttribute('src');
    try { v.load(); } catch (e) {}
    if (src && src.indexOf('blob:') === 0) URL.revokeObjectURL(src);
  };
  VideoPlayer.prototype.stats = function () {
    return { kind: 'video', t: this.v.currentTime, stalls: this.stalls, ended: this.ended, blocked: this.blocked, failed: this.failed ? this.why || true : false };
  };

  function newPlayer(kind, bucket, entry) {
    return kind === 'canvas' ? new CanvasPlayer(bucket, entry) : new VideoPlayer(bucket, entry);
  }

  // ---- early start: guess the first jar and start its downloads before the card exists ----
  var earlyClip = null;   // { key, bucket, player }
  function startClip(spec) {
    if (mode('off') || !ENGINE) return false;
    if (navigator.connection && navigator.connection.saveData) return false;
    if (document.visibilityState && document.visibilityState !== 'visible') return false;   // a background tab never attaches
    var key = keyOf(spec), entry = DATA.entries && DATA.entries[key];
    if (!usable(entry)) return false;
    var css = predictStage(PAGE);
    var bucket = css ? pickBucket(entry, css, css / entry.aspect) : null;
    if (!bucket) return false;
    if (REDUCED) { fetchBin(bucket.still); return false; }
    if (PLAYER === 'video' && !canPlay(bucket.codec)) return false;
    fetchBin(bucket.poster);
    var player = newPlayer(PLAYER, bucket, entry);
    if (player.failed) return false;
    earlyClip = { key: key, bucket: bucket, player: player };
    return true;
  }
  function dropEarly() {
    if (earlyClip) { earlyClip.player.kill(); earlyClip = null; }
  }

  function preloadModules(list, priority) {
    (list || []).forEach(function (href) {
      var link = document.createElement('link');
      link.rel = 'modulepreload';
      link.href = href;
      try { link.fetchPriority = priority; } catch (e) {}
      (document.head || document.documentElement).appendChild(link);
    });
  }

  // Which jar the page will show first, even when the finish isn't a clip's (only the model matters here).
  function guessJarModel() {
    if (PAGE === 'jars') { var g = guessJars(); return g ? g.jar : 'ceres'; }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('vp_jar_label_choices_v2') || 'null'); } catch (e) { cached = null; }
    var id = LABEL_JARS[labelJarParam()] ? labelJarParam() : cached && LABEL_JARS[cached.active] ? cached.active : 'miron-5ml-ceres';
    return id === 'black-4oz' ? 'black4oz' : id === 'miron-150ml' ? 'saturn' : id === 'miron-5ml-eris' ? 'eris' : 'ceres';
  }

  var liveStarted = false;
  function startLiveJar(priority) {
    if (liveStarted || window.VPJarPreview) return;   // the viewer is already loading its own files
    liveStarted = true;
    var unversioned = function (href) { try { return new URL(href, location.href).searchParams.has('v') ? undefined : 'no-cache'; } catch (e) { return 'no-cache'; } };
    early.get((window.VP_CDN+"jars-3d__models__") + guessJarModel() + '.glb', priority);
    if (PAGE === 'jar-labels') {
      [(window.VP_CDN+"jars-3d__production-art__manifest.json?v=cd7a2c1bc9"), (window.VP_CDN+"jars-3d__preview-art__seams-v1__manifest.json?v=9630c98266"),
       (window.VP_CDN+"jars-3d__emboss-art__manifest.json?v=e91936688a")].forEach(function (href) { early.get(href, priority, unversioned(href)); });
    }
    preloadModules(DATA.modules && DATA.modules.jar, priority);
  }

  // The sticker and label builders show the 3D sticker; posters, banners, yard signs and packaging don't.
  function startLiveSticker() {
    if (window.VPQuote3D) return;
    var cat = PARAMS.get('cat') || '', product = (PARAMS.get('product') || '').toLowerCase().replace(/[-+]/g, ' ');
    if (!/^(custom-stickers|embossed-stickers|specialty-stickers|labels)$/.test(cat) || PARAMS.has('edit') || PARAMS.has('openCart')) return;
    if (/mylar|poster|banner|yard sign|miron|flower jar|jar label|pre ?roll/.test(product)) return;
    // 10/12: the model (2.7 MB) waits until the head price shows. Started with the page at high priority it went
    // ahead of the builder's own scripts and price data on a phone link. Load event / 8 s are the fallbacks.
    var gate = new Promise(function (go) {
      var done = false;
      function fire() { if (!done) { done = true; go(); } }
      (function poll() {
        if (done) return;
        var e = document.getElementById('headPriceUnit');
        if (e && /\d/.test(e.textContent)) fire(); else setTimeout(poll, 40);
      })();
      window.addEventListener('load', fire);
      setTimeout(fire, 8000);
    });
    early.get((window.VP_CDN+"vp-sticker.glb?v=2217d1bc8d"), 'high', undefined, gate);
    preloadModules(DATA.modules && DATA.modules.quote, 'high');
  }

  function boot() {
    if (PAGE === 'jar-labels' || PAGE === 'jars') {
      loadFresh();
      var clip = startClip(PAGE === 'jar-labels' ? guessJarLabels() : guessJars());
      if (clip && earlyClip.player.kind === 'canvas') {
        // The clip's opening bytes go first (requested first, high priority); the live jar's files follow at high
        // priority right behind them, and the rest of the clip (the turn) comes last, at low priority.
        var go = function () { startLiveJar('high'); };
        earlyClip.player.onrequested = go;
        setTimeout(go, 150);
      } else {
        // The <video> player streams at the browser's media priority: the live files then wait behind it.
        startLiveJar(clip ? 'low' : 'high');
      }
    } else if (PAGE === 'configurator') {
      startLiveSticker();
    }
  }

  // ---- one stand-in per page load ----
  var S = null;        // the active stand-in
  var decided = false;
  var lastState = { attached: false };
  // The page's stage rule re-runs on every clip transition (jar-builder-preview.js syncStage; 10/12 review, round 3).
  function changed(what) { try { window.dispatchEvent(new CustomEvent('vpstandinchange', { detail: what })); } catch (e) {} }

  function css() {
    if (document.getElementById('vp-standin-css')) return;
    var style = document.createElement('style');
    style.id = 'vp-standin-css';
    style.textContent =
      '.vp-standin{position:absolute;inset:0;z-index:3;background:#fff;pointer-events:none;overflow:hidden;transform:translateZ(0)}' +
      // Three classes: the jar shop styles every image in its stage (padding 16%, contain) with two.
      '.vp-standin.vp-standin.vp-standin>video,.vp-standin.vp-standin.vp-standin>img,.vp-standin.vp-standin.vp-standin>canvas{position:absolute;inset:0;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;border:0;box-sizing:border-box;object-fit:fill;display:block;transform:translateZ(0)}' +
      '.vp-standin-stage #jar-builder-3d{transform:translateZ(0)}' +
      '.vp-standin-stage #jar-builder-3d-hint{z-index:4}' +
      '.vp-standin-photo-off>img{visibility:hidden}' +
      '.vp-standin-debug{position:absolute;left:8px;top:8px;z-index:5;pointer-events:none;font:11px/1.2 system-ui,sans-serif;letter-spacing:.04em;color:rgba(36,36,36,.6)}';
    (document.head || document.documentElement).appendChild(style);
  }

  function contentBox(stage) {
    var r = stage.getBoundingClientRect(), cs = getComputedStyle(stage);
    var bx = (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
    var by = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
    return { w: r.width - bx, h: r.height - by };
  }

  function miss(reason, extra) {
    dropEarly();
    mark('vp:standin-miss', { reason: reason, extra: extra || null });
    lastState = { attached: false, miss: reason, extra: extra || null };
    debugTag(null, 'live (' + reason + ')');
    return false;
  }

  var debugEl = null;
  function debugTag(stage, text) {
    if (!mode('debug')) return;
    stage = stage || (S && S.stage) || document.querySelector('#jl-photo-view .jl-photo, .jar-detail-img-wrap');
    if (!stage) return;
    if (!debugEl || debugEl.parentNode !== stage) {
      css();
      debugEl = debugEl || document.createElement('div');
      debugEl.className = 'vp-standin-debug';
      stage.appendChild(debugEl);
    }
    debugEl.textContent = text;
  }

  // The live jar can take over: labels on, and a raised emboss done or given RELIEF_WAIT, exactly when the jar would
  // have shown without a clip (revealReady). Older viewers: ready().
  function liveReady() {
    var live = window.VPJarPreview;
    if (!live) return false;
    var spec = window.vpJarBuilderPreview && window.vpJarBuilderPreview.spec ? window.vpJarBuilderPreview.spec() : null;
    if (S && spec && keyOf(spec) !== S.key) return false;
    var diag = window.jarArtworkDiagnostics ? window.jarArtworkDiagnostics() : null;
    if (S && diag && (diag.jar !== jarOf(S.key) || diag.status !== 'ready')) return false;
    if (typeof live.revealReady === 'function') return live.revealReady() === true;
    return !!(live.ready && live.ready());
  }

  function attach(stage, spec) {
    if (decided) return false;
    decided = true;
    return decide(stage, spec, false);
  }

  // A jar switch (product tab, jar type, jars-page card): the new jar loads hidden and plays its own opening, exactly
  // like a page open, so it gets its opening clip under the same rules (the live jar for it isn't showing yet: setJar
  // hides it until its labels are on). Only from the default view: a clip is always the angle view.
  function reattach(stage, spec) {
    if (!decided || S) return false;
    var view = document.querySelector('[data-jar-view][aria-pressed="true"]');
    if (view && view.dataset.jarView !== 'angle') return miss('view');
    return decide(stage, spec, true);
  }

  function decide(stage, spec, switching) {
    if (mode('off')) return miss('off');
    if (!ENGINE) return miss('engine');
    if (navigator.connection && navigator.connection.saveData) return miss('save-data');
    if (PARAMS.has('edit') || PARAMS.has('openCart')) return miss('edit');
    if (document.visibilityState && document.visibilityState !== 'visible') return miss('hidden-page');
    var key = keyOf(spec), entry = DATA.entries && DATA.entries[key];
    if (!usable(entry)) return miss('no-entry', key);
    var verdict = freshness(key, entry);
    if (verdict && verdict !== 'fresh-pending') return miss(verdict, key);
    // Never over a live jar that already shows: the clip would restart its intro. Before that the stage is a blank
    // white box, and the clip only brings the dressed jar forward.
    var live = window.VPJarPreview, state = live && live.introState ? live.introState() : null;
    if (state && state.visible && !switching) return miss('live-running');
    var box = contentBox(stage);
    var bucket = pickBucket(entry, box.w, box.h);
    if (!bucket) return miss('size', Math.round(box.w) + 'x' + Math.round(box.h) + '@' + Math.min(window.devicePixelRatio || 1, 2));
    var kind = PLAYER;
    if (!REDUCED && kind === 'video' && !canPlay(bucket.codec)) return miss('codec', bucket.codec);

    css();
    var root = document.createElement('div');
    root.className = 'vp-standin';
    root.setAttribute('aria-hidden', 'true');
    S = { stage: stage, root: root, key: key, entry: entry, bucket: bucket, player: null, img: null, w: backingOf(box.w),
          thumbs: false, readyAt: 0, pending: '', handing: '', frozen: false, done: false, raf: 0, urls: [], t0: performance.now(),
          shownAt: 0, thumbsApplied: false, kind: PLAYER, switching: switching };
    var img = document.createElement('img');   // frame 0 (or the reduced-motion still), under the player
    img.alt = ''; img.decoding = 'async';
    root.appendChild(img);
    S.img = img;
    var st = S;
    // Attach first, then start: begin() (or a local freshness verdict) may step aside at once, and cancel() must find
    // the attachment it undoes (the listeners, the photo-off class, the root) already in place (10/12 review).
    stage.classList.add('vp-standin-stage', 'vp-standin-photo-off');
    var canvas = stage.querySelector('#jar-builder-3d');
    if (canvas) stage.insertBefore(root, canvas.nextSibling); else stage.appendChild(root);
    stage.addEventListener('pointerdown', onPointer, true);
    document.addEventListener('jarthumbs', onThumbs, true);
    // The live jar may already be loading (this script arrived after the page's first jar): hold it now. On a jar
    // switch the page's adapter sets the new jar with the hold itself (holdFor), right after this.
    if (!switching && live && live.set && state && !state.held) live.set({ hold: true });
    mark('vp:standin-attached', { key: key, size: bucket.size, reduced: REDUCED, player: REDUCED ? 'still' : PLAYER, verdict: verdict || 'ok', switching: switching });
    lastState = { attached: true, key: key, size: bucket.size, reduced: REDUCED, player: REDUCED ? 'still' : PLAYER };
    debugTag(stage, 'clip ' + bucket.size);
    if (verdict) {
      // Local preview, the daemon's list not in yet (a few ms): the stand-in stays a blank white box (what the stage
      // shows without a clip) until it says this clip still matches; otherwise it steps aside for the live jar.
      whenFresh(function () {
        if (S !== st || st.done) return;
        var v = freshness(key, entry);
        if (v) { cancel(v); return; }
        begin(st);
      });
    } else {
      begin(st);
    }
    // Stepped aside already (an early player that had failed, a stale local clip): nothing left to drive.
    if (S !== st || st.done) return false;
    S.raf = requestAnimationFrame(tick);
    changed('attach');
    return true;
  }

  // Poster (or reduced-motion still) and the player.
  function begin(st) {
    var bucket = st.bucket, entry = st.entry, img = st.img, key = st.key;
    st.begun = true;
    blobUrl(REDUCED ? bucket.still : bucket.poster, 'image/webp').then(function (u) {
      if (S !== st || st.done) { URL.revokeObjectURL(u); return; }
      st.urls.push(u); img.src = u;
      var shown = function () {
        if (S !== st || st.done) return;
        if (!st.shownAt) {
          st.shownAt = performance.now();
          mark('vp:standin-poster', { key: st.key, ms: Math.round(st.shownAt - st.t0) });
          if (st.player) st.player.shown(nowAbs());
        }
        if (REDUCED) firstFrame(st);
        if (entry.thumbs) applyThumbs(st, entry.thumbs);
      };
      if (img.decode) img.decode().then(shown, shown); else img.onload = shown;
    }, function () {
      // No poster either: a dead player has nothing to show, so step aside now (the task that attached has finished).
      if (S === st && !st.done && (REDUCED || st.deadPlayer) && !st.started) cancel('player-failed');
    });
    if (!REDUCED) {
      var kind = st.kind;
      var player = earlyClip && earlyClip.key === key && earlyClip.bucket === bucket && earlyClip.player.kind === kind ? earlyClip.player : null;
      if (!player) dropEarly();
      earlyClip = null;
      startPlayer(st, player || newPlayer(kind, bucket, entry));
    }
  }

  function startPlayer(st, player) {
    st.player = player;
    st.tried = st.tried || {};
    st.tried[player.kind] = true;
    player.onfirst = function () { firstFrame(st); if (st.entry.thumbs) applyThumbs(st, st.entry.thumbs); };
    player.onmoved = function () { if (S === st && !st.playMarked) { st.playMarked = true; mark('vp:standin-playing', { key: st.key, player: player.kind }); } };
    player.onfail = function (why, started) {
      if (S !== st || st.done || st.player !== player) return;
      mark('vp:standin-miss', { reason: 'player-failed', player: player.kind, why: why, started: started });
      // Nothing drawn yet: the other player can still bring the opening on time (the poster stays meanwhile).
      if (!started && !st.tried.video && canPlay(st.bucket.codec)) { player.kill(); startPlayer(st, newPlayer('video', st.bucket, st.entry)); }
      // No player left and the poster not on screen yet (10/12): the poster is the dressed jar's first frame and a dead
      // player still hands over at frame 0, so give it a moment; without it, step aside so the live jar runs as with
      // no clip and the page's 20 s give-up can show its fixed still. Deferred: this can run inside attach() when an
      // early clip had already failed, and attach() must finish first (10/12 review).
      else if (!started && !st.shownAt) {
        st.deadPlayer = true;
        setTimeout(function () { if (S === st && !st.done && !st.shownAt && !st.started) cancel('player-failed'); }, 1500);
      }
    };
    player.onblocked = function () {
      // A refused <video> play (iOS Low Power Mode): the canvas player isn't subject to it.
      if (S !== st || st.done || st.player !== player || st.tried.canvas || !canvasPlayable() || mode('video')) return;
      player.kill(); startPlayer(st, newPlayer('canvas', st.bucket, st.entry));
    };
    if (player.failed) { player.onfail(player.why, false); return; }
    player.mount(st.root, st.w, st.w);
    if (st.shownAt) player.shown(nowAbs() - (performance.now() - st.shownAt));
    player.play();
  }

  function applyThumbs(st, url) {
    if (st.thumbsApplied) return;
    st.thumbsApplied = true;
    var key = st.key;
    thumbUrls(url).then(function (urls) {
      var spec = window.vpJarBuilderPreview && window.vpJarBuilderPreview.spec ? window.vpJarBuilderPreview.spec() : null;
      if (S !== st || st.done || st.key !== key || keyOf(st.entry.spec) !== key || (spec && keyOf(spec) !== key)) { urls.forEach(function (u) { URL.revokeObjectURL(u); }); return; }
      // Kept for the page's life (~15 KB): the view thumbnails may still show them after the hand-off.
      var order = { angle: 0, side: 1, top: 2 };
      var buttons = document.querySelectorAll('[data-jar-view]');
      for (var i = 0; i < buttons.length; i++) {
        var img = buttons[i].querySelector('img'), at = order[buttons[i].dataset.jarView];
        // Only fill empty views (on a jar switch: the old jar's views); the live jar's own snapshots replace these.
        if (img && at !== undefined && (!img.dataset.thumbKey || img.dataset.thumbKey === 'standin')) { img.src = urls[at]; img.dataset.thumbKey = 'standin'; img.dataset.shows = 'standin|' + st.key.split('|').slice(0, 3).join('|'); }
      }
    }, function () {});
  }

  function firstFrame(st) {
    if (!st || st.started) return;
    st.started = true;
    mark('vp:standin-first-frame', { key: st.key, ms: Math.round(performance.now() - st.t0), player: st.player ? st.player.kind : 'still' });
  }

  function onPointer() { request('touch'); }
  function onThumbs(event) {
    if (!S) return;
    var spec = window.vpJarBuilderPreview && window.vpJarBuilderPreview.spec ? window.vpJarBuilderPreview.spec() : null;
    if (!spec || (event && event.detail && event.detail.key === JSON.stringify(spec) && keyOf(spec) === S.key)) S.thumbs = true;
  }

  // Ask for the hand-off as soon as the live jar can show, without waiting for a calm moment.
  function request(reason) {
    if (!S || S.done || S.frozen) return;
    S.pending = S.pending || reason;
    // The customer asked for the live jar (a touch, a view, another finish): the clip keeps the opening it has and
    // stops fetching its turn, so the live jar gets the whole link.
    if (S.player && S.player.dropTail) S.player.dropTail();
    if (liveReady() && S.begun) handoff(S.pending);
  }

  function calm(t) {
    var w = S.entry.calm || [];
    for (var i = 0; i < w.length; i++) if (t >= w[i][0] && t < w[i][1]) return true;
    return false;
  }

  function tick() {
    if (!S || S.done || S.frozen) return;
    S.raf = 0;
    var now = performance.now(), ready = liveReady(), p = S.player;
    if (ready && !S.readyAt) S.readyAt = now;
    // The view thumbnails are drawn under the clip (a long frame); give them a moment, then go anyway. A clip that
    // already stopped (ended, stalled, holding) doesn't wait for them: the jar should move again as soon as it can.
    var stopped = !!p && p.started && p.stopped(now);
    var thumbsOk = S.thumbs || stopped || (S.readyAt && now - S.readyAt > 1200);
    if (ready && thumbsOk && !S.handing && S.begun) {
      var reason = S.pending;
      if (!reason && !mode('manual')) {
        if (!p) reason = 'still';
        else if (!p.started) reason = 'frame0';
        else if (p.ended) reason = 'ended';
        else if (stopped) reason = 'stalled';
        else if (calm(p.time())) reason = 'calm';
      }
      if (reason) handoff(reason);
    }
    if (!S || S.done) return;
    if (mode('debug') && p) debugTag(S.stage, 'clip ' + S.bucket.size + ' · ' + p.time().toFixed(2) + 's' + (ready ? ' · live ready' : ''));
    S.raf = requestAnimationFrame(tick);
  }

  // Pause the clip, learn the frame on screen (the canvas player answers from its worker), draw the live jar on that
  // frame and hide the clip in the same task.
  function handoff(reason) {
    if (!S || S.done || S.frozen || S.handing) return false;
    var live = window.VPJarPreview;
    if (!live || !live.seekIntro) return false;
    var st = S, key = st.key, player = st.player;
    st.handing = reason;
    // A passive moment ('calm', 'frame0', 'stalled', 'ended') is re-checked on the frame actually on screen; a touch,
    // a view pick or a finish change takes whatever frame that is.
    var when = reason === 'calm' || reason === 'frame0' ? 'calm' : reason === 'stalled' || reason === 'ended' ? 'stopped' : 'now';
    var go = function (k, stopped) {
      if (S !== st || st.done || st.frozen) return;
      st.handing = '';
      if (st.key !== key || st.player !== player || window.VPJarPreview !== live || !liveReady()) { if (st.player) st.player.resume(); return; }
      if (k === null) return;            // the clip moved on past that moment: the next one comes from tick()
      if (!st.player) { k = 0; stopped = false; }
      var t = k / st.entry.fps;
      // A clip that wasn't advancing on this frame (ended, stalled, held) resumes the turn with an ease-in.
      var pose = (reason === 'view' || reason === 'touch' || reason === 'spec') && live.pose ? live.pose() : null;
      try {
        if (!live.seekIntro(t, !!stopped)) { if (st.player) st.player.resume(); return; }
        if (pose && live.restorePose) live.restorePose(pose);
      } catch (error) { cancel('handoff-error'); return; }
      st.root.style.visibility = 'hidden';   // same task as the live draw: one composited frame changes over
      st.done = true;
      var detail = { t: t, k: k, reason: reason, key: st.key, size: st.bucket.size, ms: Math.round(performance.now() - st.t0),
                     player: st.player ? st.player.kind : 'still', resume: !!stopped };
      mark('vp:standin-handoff', detail);
      lastState = { attached: true, key: st.key, size: st.bucket.size, handoff: detail, player: st.player ? st.player.stats() : null };
      debugTag(st.stage, 'live @' + t.toFixed(3) + 's (' + reason + ')');
      S = null;
      cleanup(st, 500);
      changed('handoff');
    };
    if (st.player) st.player.pause(go, when); else go(0, false);
    return true;
  }

  function cleanup(st, delay) {
    st.done = true;
    if (st.raf) cancelAnimationFrame(st.raf);
    st.stage.removeEventListener('pointerdown', onPointer, true);
    document.removeEventListener('jarthumbs', onThumbs, true);
    st.stage.classList.remove('vp-standin-photo-off');
    if (st.player) st.player.kill();
    setTimeout(function () {
      if (st.root.parentNode) st.root.parentNode.removeChild(st.root);
      st.urls.forEach(function (u) { setTimeout(function () { URL.revokeObjectURL(u); }, 2000); });
    }, delay);
  }

  // The jar or the page state moved away from the clip: drop it and let the live jar run as it would.
  function cancel(reason) {
    if (!S) return;
    var st = S;
    S = null;
    st.root.style.visibility = 'hidden';
    mark('vp:standin-miss', { reason: 'cancel:' + (reason || ''), key: st.key });
    lastState = { attached: true, key: st.key, size: st.bucket.size, cancelled: reason || '', player: st.player ? st.player.stats() : null };
    cleanup(st, 0);
    if (window.VPJarPreview && window.VPJarPreview.release) window.VPJarPreview.release();
    debugTag(st.stage, 'live (' + (reason || 'cancel') + ')');
    changed('cancel');
  }

  // The live jar failed (WebGL): keep the clip's dressed frame in place rather than a blank box.
  function freeze() {
    if (!S || S.frozen) return;
    S.frozen = true;
    if (S.raf) cancelAnimationFrame(S.raf);
    mark('vp:standin-miss', { reason: 'live-failed', key: S.key });
    lastState = { attached: true, key: S.key, size: S.bucket.size, frozen: true };
    changed('freeze');
  }

  function update(spec) {
    if (!S) return;
    var key = keyOf(spec);
    if (key === S.key) return;
    if (S.frozen || !spec || jarOf(key) !== jarOf(S.key)) { cancel(spec ? 'jar' : 'no-jar'); return; }
    // Same jar, another finish: the live jar shows it as soon as it can show at all (revealReady, no calm window).
    S.key = key;
    request('spec');
  }

  // For the live jar (jar-preview-3d.js): resolves once the clip's opening bytes are in, at once without a clip (or a
  // <video> player), and never later than INTRO_WAIT after the call.
  function introLoaded() {
    return new Promise(function (resolve) {
      var p = S && !S.done && S.player;
      if (!p || p.kind !== 'canvas' || p.introIn || p.failed) { resolve(); return; }
      var t = setTimeout(resolve, INTRO_WAIT);
      p.introWaiters = (p.introWaiters || []).concat(function () { clearTimeout(t); resolve(); });
    });
  }

  function userAction(kind) { request(kind || 'user'); }
  // Tests (?vpstandin=manual): pause the clip where it is; resolves with the frame on screen. A later userAction()
  // hands off on that same frame.
  function pauseForTest() {
    return new Promise(function (resolve) {
      if (!mode('manual') || !S || !S.player) { resolve(null); return; }
      S.player.pause(function (k, stopped) { resolve({ k: k, stopped: !!stopped }); }, 'now');
    });
  }
  function holdFor(spec) { return !!S && !S.done && !S.frozen && jarOf(keyOf(spec)) === jarOf(S.key); }
  function active() { return !!S && !S.done; }

  window.VPStandin = {
    keyOf: keyOf, attach: attach, reattach: reattach, update: update, cancel: cancel, freeze: freeze, userAction: userAction,
    holdFor: holdFor, active: active, pauseForTest: pauseForTest, frames: function () { return frameLog.slice(); }, introLoaded: introLoaded,
    state: function () {
      var p = S && S.player;
      var s = S ? { key: S.key, size: S.bucket.size, started: !!S.started, playing: !!(p && p.moved), stalled: !!(p && p.started && p.stopped(performance.now()) && !p.ended),
        ended: !!(p && p.ended), thumbs: S.thumbs, pending: S.pending, frozen: S.frozen, blocked: !!(p && p.blocked),
        time: p ? p.time() : null, player: p ? p.stats() : null } : null;
      return { engine: ENGINE, page: PAGE, mode: MODE, reduced: REDUCED, decided: decided, last: lastState, active: s,
        player: PLAYER, entries: Object.keys(DATA.entries || {}).length };
    }
  };

  try { boot(); } catch (e) { earlyClip = null; }
  // Async script: the page may already have shown its stage. Tell its adapter it can still decide (vp-standin.js
  // attaches only while the live jar isn't showing).
  try { window.dispatchEvent(new Event('vpstandin')); } catch (e) {}
})();
